// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:49.920Z
// Property: Acacia Park Apts. (ID: 6767906449165582)
// Collections: 34 amenities, 4 floorplans (live), 37 photos, 68 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165582",
  "property_external_id": "lehefcf",
  "property_zillow_url": "https://www.zillow.com/homedetails/No-Situs-Available-El-Paso-TX-79912/243968359_zpid/",
  "property_apartments_url": "https://www.apartments.com/acacia-park-apts-el-paso-tx/lehefcf/",
  "property_google_business_url": "https://www.google.com/maps/place/Acacia+Park+Apartments/data=!4m2!3m1!1s0x0:0xae9defce309fa3b5?sa=X&ved=2ahUKEwjYuKLX8LySAxXALkQIHTaMH5MQ_BJ6BAhWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47606143147",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "acacia-park-apts.",
  "property_name": "Acacia Park Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/acacia-park/",
  "property_domain": null,
  "property_address": "5848 Acacia Circle",
  "property_full_address": "5848 Acacia Circle, El Paso, TX, 79912",
  "property_address_1": "5848 Acacia Circle",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79912",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Upper Mesa Hills",
  "property_address_latitude": "31.8268",
  "property_address_longitude": "-106.5197",
  "property_email": "acaciapark@caseusa.com",
  "property_phone": "(915) 233-2394",
  "property_call_tracking_phone": "844-794-3108",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Acacia Park Apts., where comfort meets convenience in beautiful El Paso, Texas. Choose from our spacious one, two, and three-bedroom floor plans, complemented by top-notch amenities like a shimmering pool, fitness center, and dog park. Your ideal home awaits—schedule a tour or browse our availability today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your Dream Home at Acacia Park Apts. in El Paso, Texas!**\n\nWelcome to Acacia Park Apartments, where comfort and convenience meet in the heart of El Paso. Our thoughtfully designed community offers a variety of floor plans, including one, two, and three-bedroom apartments, perfect for any lifestyle. Enjoy modern living with high-end amenities, like stainless steel appliances, washer/dryer hookups, and spacious walk-in closets that cater to all your storage needs. \n\nStep outside your door and dive into a wealth of amenities! Take a refreshing dip in our sparkling pool, break a sweat in the fully-equipped fitness center, or unwind with friends at our picnic area and BBQ grill. Families will love our playground, while pet owners will appreciate our gated dog park. The community is also conveniently located near public transportation, ensuring easy access to everything El Paso has to offer.\n\nWith 24-hour access, on-site maintenance, and management, you can enjoy peace of mind in a smoke-free environment. Our clubhouse and business center serve as the perfect gathering or work spaces, while basketball courts and a sun-soaked sundeck amplify your leisure time.\n\nAt Acacia Park, we prioritize your comfort with essential features like air conditioning, ceiling fans, and cable-ready apartments. Our picturesque balconies and patios provide the perfect spot to relax and enjoy the outdoors.\n\nDon’t wait to find your ideal home. **Browse our availability or schedule a tour today to experience the vibrant lifestyle at Acacia Park Apartments!** Your new beginning awaits in El Paso!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019fb44b-23c3-7021-ad82-d83247f56d18.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building entrance with green awning and palm trees",
    "public_id": "019fb44b-23c3-7021-ad82-d83247f56d18",
    "storage_key": "property/6767906449165582/019fb44b-23c3-7021-ad82-d83247f56d18.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "336",
  "property_year_built": "1995",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.10714285714286",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions Apply.",
  "property_pet_policy_description": "Breed Restrictions Apply. Deposits vary on size. Contact the leasing office for more information.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://acaciaparkapartmentselpaso.securecafe.com/onlineleasing/acacia-park-apts/floorplans.aspx",
  "property_resident_portal_url": "https://acaciaparkapartmentselpaso.securecafe.com/residentservices/acacia-park-apts/userlogin.aspx",
  "property_apply_now_url": "https://acaciaparkapartmentselpaso.securecafe.com/onlineleasing/acacia-park-apts/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-65ac-7129-a45b-261982edc03b.webp",
  "property_primary_logo_media": {
    "alt_text": "Acacia Park Apartment Homes logo",
    "public_id": "019cfb37-65ac-7129-a45b-261982edc03b",
    "storage_key": "property/6767906449165582/019cfb37-65ac-7129-a45b-261982edc03b.webp",
    "width": 1249,
    "height": 501
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb38-8d1b-7659-9247-ef335d5b545a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb38-8d1b-7659-9247-ef335d5b545a",
    "storage_key": "property/6767906449165582/019cfb38-8d1b-7659-9247-ef335d5b545a.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-65ac-7129-a45b-261982edc03b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Acacia Park Apartment Homes logo",
    "public_id": "019cfb37-65ac-7129-a45b-261982edc03b",
    "storage_key": "property/6767906449165582/019cfb37-65ac-7129-a45b-261982edc03b.webp",
    "width": 1249,
    "height": 501
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb38-c854-74d5-a0f9-23c6c89ffc9e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Acacia Park Apartment Homes logo",
    "public_id": "019cfb38-c854-74d5-a0f9-23c6c89ffc9e",
    "storage_key": "property/6767906449165582/019cfb38-c854-74d5-a0f9-23c6c89ffc9e.webp",
    "width": 640,
    "height": 257
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#58595b",
  "property_secondary_color": "#ac6c54",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#979a82",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1075 - 1075",
  "property_sqft_min": "1075",
  "property_sqft_max": "1075",
  "property_price_range": "1795 - 1795",
  "property_price_min": "1795",
  "property_price_max": "1795",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/acaciaparkapartmentselpaso/photos/d41d8cd9/1315018170049187/",
  "property_instagram_url": "https://www.instagram.com/acacia_park_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJW00ny-lX54YRtaOfMM7vna4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/acacia-park-apartments-el-paso-3",
  "property_tiktok_url": "https://www.tiktok.com/@acaciapark1",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Acacia Park Apts.",
  "property_home_romance_title": "Find Your Haven, Where Comfort Meets Connection",
  "property_home_amenities_blurb": "Welcome to Acacia Park Apts. in El Paso, where comfort meets convenience. Choose from stylish one, two, or three-bedroom layouts designed for modern living. Relax by the pool, get active in the fitness center, or enjoy a sunny day at the dog park. Elevate your lifestyle today!",
  "property_home_floorplans_blurb": "At Acacia Park Apts. in vibrant El Paso, Texas, spacious living awaits you. Choose from thoughtfully designed one, two, or three-bedroom floor plans – each tailored for your lifestyle. Dive into comfort and style by browsing our available homes to find the perfect fit for you. Your ideal apartment starts here!",
  "property_home_gallery_blurb": "At Acacia Park Apts. in El Paso, your dream lifestyle awaits. Choose from our spacious one, two, or three-bedroom floor plans, while enjoying amenities like our sparkling pool, modern fitness center, and inviting dog park. Picture yourself relaxing on the sundeck or whipping up meals in a stylish kitchen!",
  "property_home_neighborhood_blurb": "At Acacia Park Apts. in vibrant El Paso, your ideal home awaits in one-, two-, or three-bedroom floor plans. Nestled near Fort Bliss, the University of Texas at El Paso, and stunning Franklin Mountains State Park, our community offers endless opportunities to connect with nature, culture, and local attractions. See what’s around!",
  "property_home_reviews_blurb": "At Acacia Park Apts. in El Paso, residents rave about our attentive maintenance team and welcoming atmosphere. One happy tenant shared, \"The office staff is friendly and take immediate action,\" making every day feel like home. Discover the charm of our community and see what our residents have to say!",
  "property_neighborhood_blurb": "Nestled in vibrant El Paso, Acacia Park Apts. offers more than just a place to live. Enjoy easy access to the Franklin Mountains State Park, the El Paso Zoo and Botanical Gardens, and the cultural hub of the University of Texas at El Paso. Your ideal lifestyle awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Acacia Park Apts. in El Paso, discover a vibrant lifestyle with amenities designed for comfort and convenience. Splash in the refreshing pool, stay fit in our state-of-the-art fitness center, or unwind in the dog park. Experience modern living with stylish interiors and spacious floor plans tailored for your needs.",
  "property_applynow_blurb": "At Acacia Park Apts. in El Paso, Texas, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans, each bursting with modern amenities. Dive into our refreshing pool, enjoy workouts in the fitness center, or unwind at the dog park. Lease your new home online today!",
  "property_contactus_blurb": "At Acacia Park Apts. in vibrant El Paso, choose from one, two, or three-bedroom floor plans designed for your lifestyle. Experience comfort and convenience in a community that feels like home. Have questions? Contact our leasing team today to find the perfect space for you!",
  "property_faqs_blurb": "At Acacia Park Apts. in El Paso, Texas, your ideal living space awaits—whether you seek a cozy one-bedroom, a spacious two-bedroom, or a luxurious three-bedroom layout. For insights into our community and services, dive into our FAQs page and find the answers you need today!",
  "property_floorplans_blurb": "At Acacia Park Apts. in vibrant El Paso, Texas, your ideal living space awaits! Choose from thoughtfully designed one, two, and three-bedroom apartments, each offering unique features to suit your lifestyle. Embrace comfort and style—explore our range of floor plans and uncover your perfect home today!",
  "property_gallery_blurb": "At Acacia Park Apts. in sunny El Paso, every moment feels like a breath of fresh air. From the sparkling pool to the inviting dog park, our vibrant community offers unique floor plans and top-notch amenities. Picture yourself relaxing on your private patio—here, your dream lifestyle awaits!",
  "property_interactivemap_blurb": "At Acacia Park Apts. in El Paso, Texas, your ideal living space awaits! Choose from spacious one, two, or three-bedroom floor plans tailored for comfort. Enjoy amenities like a refreshing pool, fitness center, and dog park. Navigate your future home effortlessly with our interactive community map today!",
  "property_pets_blurb": "Welcome to Acacia Park Apts in vibrant El Paso, Texas, where modern living meets comfort. Enjoy stylish interiors and lush landscapes while being near local attractions. Pet lovers, inquire about our breed-specific policies and varying deposit options to make your new home a perfect fit for all family members.",
  "property_referafriend_blurb": "At Acacia Park Apts. in vibrant El Paso, Texas, our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. Share the love of community by referring a friend today; great friends make the best neighbors! Join us in creating a welcoming living experience filled with connection and comfort.",
  "property_residentaccess_blurb": "Welcome to Acacia Park Apts. in vibrant El Paso, Texas! Choose from our thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and take full advantage of community perks—all just a click away!",
  "property_reviews_blurb": "At Acacia Park Apts. in El Paso, residents cherish their homes amid serene landscapes reminiscent of 90s Seattle. One resident highlights, \"the office staff is friendly and take immediate action.\" Experience a community where timely maintenance and a cozy atmosphere create the perfect living environment. See what our residents have to say!",
  "property_created_at": "1753982376594",
  "property_scheduletour_blurb": "At Acacia Park Apts. in vibrant El Paso, Texas, our diverse floor plans—from cozy one-bedroom to spacious three-bedroom options—cater to every lifestyle. Experience the charm of community living and envision your new home. Curious about resident experiences? Dive in and see what they love about our welcoming community!",
  "property_thankyou_blurb": "Thank you for reaching out to Acacia Park Apts. in vibrant El Paso, Texas! Our community offers a variety of spacious floor plans, including one, two, and three-bedroom options designed for your comfort. A team member will connect with you soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Experience the charm of Acacia Park Apts. in sunny El Paso, Texas. Choose from a variety of floor plans – one, two, or three bedrooms – each designed for comfort and style. Ready to experience your new home? Step inside with our virtual tour and envision your perfect space today!",
  "property_copyright": "2025 All Rights Reserved. Acacia Park Apts.",
  "property_seo_title_home": "Acacia Park Apts. |  Apartments in El Paso, Texas",
  "property_seo_description_home": "Experience the ultimate comfort at Acacia Park Apts. in El Paso. From spacious floor plans to premium amenities, your perfect home awaits—make it yours today!",
  "property_seo_title_floorplans": "Floor Plans | El Paso, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Acacia Park Apts. in El Paso! Choose from spacious one, two, or three-bedroom floor plans that perfectly fit your lifestyle.",
  "property_seo_title_amenities": "Amenities | El Paso, Texas Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Acacia Park Apts. in El Paso! Enjoy a resort-style pool, fitness center, dog park, and spacious layouts. Live your best life—comfort awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, Texas",
  "property_seo_description_gallery": "Imagine life at Acacia Park Apts. in El Paso—luxurious amenities, spacious floor plans, and a vibrant community await. Check out our photo gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | Acacia Park Apts. Apartments",
  "property_seo_description_virtualtours": "Experience the vibrant lifestyle at Acacia Park Apts. in El Paso! Tour our one, two, and three-bedroom homes—your next adventure awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Acacia Park Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Acacia Park Apts. in El Paso! Browse our interactive map for spacious one-to-three bedroom layouts and top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, Texas",
  "property_seo_description_neighborhood": "Uncover the vibrant life around Acacia Park Apts. in El Paso! Experience local favorites and nearby gems just steps from your new home. Explore today!",
  "property_seo_title_contact": "Contact Us | Acacia Park Apts.",
  "property_seo_description_contact": "Connect with our friendly leasing team at Acacia Park Apts. in El Paso! Whether you need info on one, two, or three-bedroom options, we're here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, Texas",
  "property_seo_description_faqs": "Find answers to your questions at Acacia Park Apts. in El Paso! Our vibrant community offers top-notch amenities and spacious floor plans for modern living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, Texas",
  "property_seo_description_reviews": "Join the Acacia Park Apts. family in El Paso! Check out glowing reviews and see why our one to three-bedroom homes with 5-star amenities make life blissful!",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, Texas",
  "property_seo_description_applynow": "Find your perfect home at Acacia Park Apts. in El Paso! Enjoy spacious floor plans, modern amenities, and a vibrant community. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Acacia Park Apts.",
  "property_seo_description_residentaccess": "Manage your Acacia Park living experience seamlessly! Log in to the resident portal for rent payments, maintenance requests, and exclusive community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Acacia Park Apts.",
  "property_seo_description_referafriend": "Refer a friend to Acacia Park Apts in El Paso and build a vibrant community together. Great friends make great neighbors—share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Acacia Park Apts.",
  "property_seo_description_scheduletour": "Experience El Paso living at Acacia Park Apts. Schedule a tour today and uncover your future home in this vibrant community filled with modern amenities!",
  "property_seo_title_privacy": "Privacy Policy | Acacia Park Apts.",
  "property_seo_description_privacy": "Your privacy matters at Acacia Park Apts in El Paso. Dive into our commitment to your data security by reviewing our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Acacia Park Apts.",
  "property_seo_description_accessibility": "At Acacia Park Apts in El Paso, we champion digital inclusion and accessibility for all. Join our welcoming community where everyone thrives!",
  "property_seo_title_sitemap": "Sitemap | Acacia Park Apts.",
  "property_seo_description_sitemap": "Uncover the charm of Acacia Park Apts in El Paso! Navigate our sitemap to find your dream space in a vibrant community designed for modern living.",
  "property_seo_title_thankyou": "Thank You | Acacia Park Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Acacia Park Apts in El Paso! Expect a prompt reply from our team to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864685036",
  "amenities": [
    {
      "id": "ec_dbe7f6c3aa6c5fd8a67f500b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396164",
      "title": "24-Hour Fitness Center with Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d96a9ae65e371494d3601c79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396165",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5f0ae8d7420f49d48bf9e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396166",
      "title": "Resort-Style Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_464b0e1969a08fdd24e48a69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396167",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b92267767082fd991ce5d28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396168",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24ce88267c5eb723038a7991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396170",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_538cc6fb7620cdd3a0de5b93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396171",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d77829e220d974145f074c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396172",
      "title": "Onsite Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44ca4fd6db23d738ef7f7711",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396173",
      "title": "Package Receiving Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26f67e3f2b9e4be8e157738b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396174",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21132025c1959a438943288a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396175",
      "title": "Reserved Covered Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3bd963d7c6ba2a305539c98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396176",
      "title": "Ideal Location Near Fort Bliss",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f81d5c44dd067ae7f5f90379",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396177",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e933cb3cf476754c7223fd6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396178",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49566b7a63e2788716ab90be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396179",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ce41a8951cfbf3549588d25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396180",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b261fea7f43424b069e692a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396181",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9484679e6194c6467090adc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396183",
      "title": "Military Discounts Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f113cd48106e96656e775203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127396184",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c446568c95a6b3c55699da06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397679",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f750c3ec784065a19aee006c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397680",
      "title": "Private Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9241697da24bafb271856a75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397681",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c975f5560e0c8974fa6d724e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397682",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b31f9bdf05c5b0bfd8f53849",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397683",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26a6b161fa5ddedd7e43bf1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397684",
      "title": "Refrigerated Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d9804d809ef75cc866e4dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397685",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa2744f2b4ba90fba3643a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397686",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_992c3751a2529be1270d7d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397687",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1764d1883254532153443bd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397688",
      "title": "Exterior Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_270c8eabae14023f081200ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397689",
      "title": "Spacious Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b4d10b99fb09f6f4c768d05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397690",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ff11800aacfb99b91a73109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397691",
      "title": "Beautiful Chef's Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2cc369a61ee2a54a5282bdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397692",
      "title": "Upgraded Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f7a4f263442083b136fafa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "yardi",
      "external_id": "127397694",
      "title": "Get connected to super fast internet powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0540bdd0-c2e6-43ad-933f-163814b42457",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-59b6-7714-8585-dd1a2762a2fe.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily building with a covered entrance and landscaping.",
        "public_id": "019e1764-59b6-7714-8585-dd1a2762a2fe",
        "storage_key": "property/6767906449165582/019e1764-59b6-7714-8585-dd1a2762a2fe.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Attractive building exterior with a welcoming covered entryway, surrounding green spaces, and mature trees.",
      "link": "",
      "alt_text": "Exterior of a multifamily building with a covered entrance and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7696cc87-ec51-4768-8e38-73b176ff5aa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-42c1-73d8-997a-540494ed6564.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with a parking lot in the foreground.",
        "public_id": "019e1764-42c1-73d8-997a-540494ed6564",
        "storage_key": "property/6767906449165582/019e1764-42c1-73d8-997a-540494ed6564.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the apartment building's exterior, showcasing its architecture and the surrounding parking area.",
      "link": "",
      "alt_text": "Exterior view of the apartment building with a parking lot in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1a3717e-e4e1-4303-a72d-49ffd26ec84e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-64c9-75a9-9d12-9448b0b8a277.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and playful dog silhouettes on walls.",
        "public_id": "019e1764-64c9-75a9-9d12-9448b0b8a277",
        "storage_key": "property/6767906449165582/019e1764-64c9-75a9-9d12-9448b0b8a277.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our pet-friendly community! This dedicated dog park features agility tunnels, a fire hydrant, and fun dog-themed decor for your furry friends to enjoy.",
      "link": "",
      "alt_text": "Dog park with agility equipment and playful dog silhouettes on walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_238d898b-f79b-4bce-b12a-676ff974cc0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-523b-724e-9f3f-e975abef3120.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot in foreground.",
        "public_id": "019e1764-523b-724e-9f3f-e975abef3120",
        "storage_key": "property/6767906449165582/019e1764-523b-724e-9f3f-e975abef3120.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, showcasing the architecture and surrounding landscaping. Includes a parking lot for residents.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot in foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3a540615-e949-4eee-a306-33d1a4732b79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-30f3-733e-bd4c-8726acba6b9a.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings for children.",
        "public_id": "019e1764-30f3-733e-bd4c-8726acba6b9a",
        "storage_key": "property/6767906449165582/019e1764-30f3-733e-bd4c-8726acba6b9a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Children's playground area with sand, slides, and swings, surrounded by residential buildings and landscaping.",
      "link": "",
      "alt_text": "Playground with slides and swings for children.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9738591a-2285-4e93-a4f0-e5be02ce890f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-2f39-7722-954a-b21f052c3758.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with mountains in the background",
        "public_id": "019e1764-2f39-7722-954a-b21f052c3758",
        "storage_key": "property/6767906449165582/019e1764-2f39-7722-954a-b21f052c3758.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our outdoor court, perfect for staying active and having fun.",
      "link": "",
      "alt_text": "Outdoor basketball court with mountains in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3d8f4d77-f507-4abd-899d-09420ece5844",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-36f0-75ee-947a-f978dae183a5.webp",
      "image_media": {
        "alt_text": "Playground area with slides, swings, and a see-saw under blue canopies.",
        "public_id": "019e1764-36f0-75ee-947a-f978dae183a5",
        "storage_key": "property/6767906449165582/019e1764-36f0-75ee-947a-f978dae183a5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a colorful play structure with slides, swings, and more, all shaded by protective canopies.",
      "link": "",
      "alt_text": "Playground area with slides, swings, and a see-saw under blue canopies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5f8658b-f574-49f1-873d-873ac7b65478",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-0d99-764d-ad1c-5290dfb30856.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a sink, toilet, and bathtub.",
        "public_id": "019e1764-0d99-764d-ad1c-5290dfb30856",
        "storage_key": "property/6767906449165582/019e1764-0d99-764d-ad1c-5290dfb30856.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy this clean and modern bathroom featuring a spacious vanity, a comfortable toilet, and a relaxing bathtub. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a sink, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ab77176-eb73-4a58-bdcf-46b9af0859b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-1524-7408-ab23-bec56defbae6.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, red and white bedding, and a walk-in closet.",
        "public_id": "019e1764-1524-7408-ab23-bec56defbae6",
        "storage_key": "property/6767906449165582/019e1764-1524-7408-ab23-bec56defbae6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with elegant red and white linens, complemented by a stylish headboard and a convenient walk-in closet. This room offers a serene retreat.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, red and white bedding, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ad32da29-6e6c-45f6-b5a4-4dd48867c077",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-29c3-77ce-9952-7aa53db45bb2.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with pergolas, picnic tables, and grills.",
        "public_id": "019e1764-29c3-77ce-9952-7aa53db45bb2",
        "storage_key": "property/6767906449165582/019e1764-29c3-77ce-9952-7aa53db45bb2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in our community picnic area, complete with shaded pergolas, comfortable picnic tables, and convenient grills for your convenience.",
      "link": "",
      "alt_text": "Outdoor picnic area with pergolas, picnic tables, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08ab339f-c6a7-48be-9c2f-afdf6db9d000",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-11fe-71bc-9d68-dff8c8650479.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, lamp, and dresser.",
        "public_id": "019e1764-11fe-71bc-9d68-dff8c8650479",
        "storage_key": "property/6767906449165582/019e1764-11fe-71bc-9d68-dff8c8650479.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a king-size bed with plush bedding, a dark wood nightstand with a lamp, and a dresser for storage. Neutral carpet and a large window with sheer curtains complete the serene atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, lamp, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_25d1650e-e071-4b78-85d7-0b4355379ed7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1764-1ecc-7639-89ed-f199d29ff846.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with built-in shelves and hanging rods.",
        "public_id": "019e1764-1ecc-7639-89ed-f199d29ff846",
        "storage_key": "property/6767906449165582/019e1764-1ecc-7639-89ed-f199d29ff846.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with built-in shelves and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_77097f44-fc63-4fa9-a8a9-9a0c3fb45053",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-ee45-7533-bbbc-9e7c1d083851.webp",
      "image_media": {
        "alt_text": "Cozy dining area with a round table, chairs, and a mirrored wall.",
        "public_id": "019e1763-ee45-7533-bbbc-9e7c1d083851",
        "storage_key": "property/6767906449165582/019e1763-ee45-7533-bbbc-9e7c1d083851.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a functional dining space, perfect for meals or a morning coffee, adjacent to convenient in-unit laundry facilities.",
      "link": "",
      "alt_text": "Cozy dining area with a round table, chairs, and a mirrored wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e9262fcf-e5c0-43ee-9436-770b335dbfb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-f908-75de-a760-4fea6b80dc21.webp",
      "image_media": {
        "alt_text": "Living room with TV, sofa, coffee table, and kitchen area with bar stools.",
        "public_id": "019e1763-f908-75de-a760-4fea6b80dc21",
        "storage_key": "property/6767906449165582/019e1763-f908-75de-a760-4fea6b80dc21.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a mounted TV, comfortable seating, and a modern kitchen with bar seating.",
      "link": "",
      "alt_text": "Living room with TV, sofa, coffee table, and kitchen area with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24cb2286-79be-4fd9-ba67-4f269ca19949",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-f1e5-72d8-b682-224e0cccf191.webp",
      "image_media": {
        "alt_text": "Modern living room with a black leather sofa, orange accent chairs, and abstract art.",
        "public_id": "019e1763-f1e5-72d8-b682-224e0cccf191",
        "storage_key": "property/6767906449165582/019e1763-f1e5-72d8-b682-224e0cccf191.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, accent chairs, and modern decor, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a black leather sofa, orange accent chairs, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a376cf4-fc52-49ad-91b8-6a73858eb8bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-eef5-70db-b7f3-ab6733738043.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and oven in a brightly lit kitchen with white cabinets and a large sink.",
        "public_id": "019e1763-eef5-70db-b7f3-ab6733738043",
        "storage_key": "property/6767906449165582/019e1763-eef5-70db-b7f3-ab6733738043.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Discover this spacious kitchen featuring modern stainless steel appliances, ample cabinet space, and a convenient double sink, perfect for all your culinary needs.",
      "link": "",
      "alt_text": "Stainless steel refrigerator and oven in a brightly lit kitchen with white cabinets and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14d2d0ba-3be4-4230-98f6-84158c4ed953",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-cec3-76e3-af51-b4830eee66ef.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with mountains in the background.",
        "public_id": "019e1763-cec3-76e3-af51-b4830eee66ef",
        "storage_key": "property/6767906449165582/019e1763-cec3-76e3-af51-b4830eee66ef.webp",
        "width": 2700,
        "height": 1799
      },
      "title": "Community",
      "description": "Spacious apartment complex nestled against scenic mountains, offering a vibrant community atmosphere.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1faec25d-662e-4109-ba62-f5f18ab76eff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-efed-7760-8cdc-bd8b338ed24c.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator, oven, sink, and countertops.",
        "public_id": "019e1763-efed-7760-8cdc-bd8b338ed24c",
        "storage_key": "property/6767906449165582/019e1763-efed-7760-8cdc-bd8b338ed24c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances including a refrigerator and oven, a double sink with a gooseneck faucet, and ample counter space.",
      "link": "",
      "alt_text": "Kitchen with stainless steel refrigerator, oven, sink, and countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_94e97c32-e723-45cd-bfd3-2bba82d2fde4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-cf42-736d-9eb5-15ec931bf79a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with mountains in the background, featuring a pool and courtyard.",
        "public_id": "019e1763-cf42-736d-9eb5-15ec931bf79a",
        "storage_key": "property/6767906449165582/019e1763-cf42-736d-9eb5-15ec931bf79a.webp",
        "width": 2700,
        "height": 1799
      },
      "title": "Community",
      "description": "Discover a resort-style living experience with our sparkling pool and beautifully landscaped courtyards, all set against a stunning mountain backdrop.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with mountains in the background, featuring a pool and courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7881bd2-40fd-4843-abcb-9d189050f0aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-cd45-76cc-bc33-f580fe9eea2c.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, nightstand, and closet.",
        "public_id": "019e1763-cd45-76cc-bc33-f580fe9eea2c",
        "storage_key": "property/6767906449165582/019e1763-cd45-76cc-bc33-f580fe9eea2c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom. Featuring a plush queen-size bed, ample closet space, and a charming nightstand, it's the perfect retreat.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, nightstand, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b74ab414-a752-4a7d-bdc7-57df3883e8a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-cce8-737f-9bdd-7e8dcfd9e0ea.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019e1763-cce8-737f-9bdd-7e8dcfd9e0ea",
        "storage_key": "property/6767906449165582/019e1763-cce8-737f-9bdd-7e8dcfd9e0ea.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with sink, a toilet, and a shower/tub combination with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2de8b193-b047-4cbf-9faa-efd8ca476bf0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1763-cec7-75cb-9c3b-5a4d61a19935.webp",
      "image_media": {
        "alt_text": "Dining table with place settings and a laundry closet with washer and dryer.",
        "public_id": "019e1763-cec7-75cb-9c3b-5a4d61a19935",
        "storage_key": "property/6767906449165582/019e1763-cec7-75cb-9c3b-5a4d61a19935.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy convenient in-unit laundry facilities and a cozy dining area in this apartment.",
      "link": "",
      "alt_text": "Dining table with place settings and a laundry closet with washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8fea5401-c5b1-44e9-ab88-8b9ea59afb20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-e27c-713a-a73a-5750c2ca838a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and storage. Toilet and shower curtain visible.",
        "public_id": "019e1762-e27c-713a-a73a-5750c2ca838a",
        "storage_key": "property/6767906449165582/019e1762-e27c-713a-a73a-5750c2ca838a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Well-appointed bathroom featuring a spacious vanity with ample storage, a modern sink, and a large mirror. Includes a toilet and a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and storage. Toilet and shower curtain visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_511aa8b8-c9d7-4dc7-a607-5707a1f5b412",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-c2ab-70ab-bbc1-9771daa83120.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and a picnic table under a pergola.",
        "public_id": "019e1762-c2ab-70ab-bbc1-9771daa83120",
        "storage_key": "property/6767906449165582/019e1762-c2ab-70ab-bbc1-9771daa83120.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our outdoor grilling station, complete with two large grills and comfortable seating under a shaded pergola.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in grills and a picnic table under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac7a5eca-780b-400f-a6f1-9842229d6a94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-d4cd-7210-83ee-565ee2bf3ed6.webp",
      "image_media": {
        "alt_text": "Empty patio with a light fixture and surrounding buildings.",
        "public_id": "019e1762-d4cd-7210-83ee-565ee2bf3ed6",
        "storage_key": "property/6767906449165582/019e1762-d4cd-7210-83ee-565ee2bf3ed6.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Enjoy your own private patio space, perfect for relaxing outdoors.",
      "link": "",
      "alt_text": "Empty patio with a light fixture and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85218d60-a814-4f35-b13a-3f43c5f8571d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-c14a-71c9-8837-88b29d56e961.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and palm trees.",
        "public_id": "019e1762-c14a-71c9-8837-88b29d56e961",
        "storage_key": "property/6767906449165582/019e1762-c14a-71c9-8837-88b29d56e961.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and soothing hot tub, surrounded by lush palm trees and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_33f6e29f-c108-492c-b3d7-324a90649d16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-827d-727c-9a76-8a2e9d87f45a.webp",
      "image_media": {
        "alt_text": "Community dining area with large table, fireplace, and TV.",
        "public_id": "019e1762-827d-727c-9a76-8a2e9d87f45a",
        "storage_key": "property/6767906449165582/019e1762-827d-727c-9a76-8a2e9d87f45a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Gather around the community dining table next to a cozy fireplace and entertainment TV, perfect for resident events or casual get-togethers.",
      "link": "",
      "alt_text": "Community dining area with large table, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b65a42f-51fe-4f42-9e6b-4de95956acb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-d5ec-736f-b369-2aa9edbdf5c1.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, white cabinets, and a black stovetop in a multifamily apartment kitchen.",
        "public_id": "019e1762-d5ec-736f-b369-2aa9edbdf5c1",
        "storage_key": "property/6767906449165582/019e1762-d5ec-736f-b369-2aa9edbdf5c1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment kitchen features a stainless steel refrigerator, ample cabinet space, a dishwasher, and a black electric stovetop, perfect for cooking.",
      "link": "",
      "alt_text": "Stainless steel refrigerator, white cabinets, and a black stovetop in a multifamily apartment kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30433392-318a-4755-8ed7-cf067eae7b09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-5b49-777a-b2df-077f2cd6f88c.webp",
      "image_media": {
        "alt_text": "Community lounge area with a round dining table, chairs, and a wall-mounted TV displaying a fall landscape.",
        "public_id": "019e1762-5b49-777a-b2df-077f2cd6f88c",
        "storage_key": "property/6767906449165582/019e1762-5b49-777a-b2df-077f2cd6f88c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in the community lounge, featuring a comfortable seating area and a large TV perfect for entertainment.",
      "link": "",
      "alt_text": "Community lounge area with a round dining table, chairs, and a wall-mounted TV displaying a fall landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe53f460-b3f5-4ce6-bf54-b57919041f16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-ab81-70dd-9ef1-615070abe3f5.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees under a blue sky with clouds.",
        "public_id": "019e1762-ab81-70dd-9ef1-615070abe3f5",
        "storage_key": "property/6767906449165582/019e1762-ab81-70dd-9ef1-615070abe3f5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush palm trees. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31f19180-4dbc-4eec-8abf-95b7f509ae91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-9b90-7678-8f69-9fb86b6bc782.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e1762-9b90-7678-8f69-9fb86b6bc782",
        "storage_key": "property/6767906449165582/019e1762-9b90-7678-8f69-9fb86b6bc782.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, stainless steel appliances including a microwave and oven, and elegant granite countertops. Perfect for all your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d6ff8d7d-50e8-44dd-8fb3-42fe0156c92f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-af8d-74b8-bf03-3b853d51c511.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees, mountains in the background.",
        "public_id": "019e1762-af8d-74b8-bf03-3b853d51c511",
        "storage_key": "property/6767906449165582/019e1762-af8d-74b8-bf03-3b853d51c511.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees, mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f435033d-e9d6-4adb-9651-4383b3a9fc26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-9cd4-77f4-8082-e6cc4360cff8.webp",
      "image_media": {
        "alt_text": "Spacious common area with seating and dining table",
        "public_id": "019e1762-9cd4-77f4-8082-e6cc4360cff8",
        "storage_key": "property/6767906449165582/019e1762-9cd4-77f4-8082-e6cc4360cff8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy comfortable seating and a communal dining area in our spacious common room, perfect for resident gatherings and relaxation.",
      "link": "",
      "alt_text": "Spacious common area with seating and dining table",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f0d4e0ae-f963-481b-b2f2-e31f834c9fbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-6f18-706b-82e2-53f4927eedd6.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e1762-6f18-706b-82e2-53f4927eedd6",
        "storage_key": "property/6767906449165582/019e1762-6f18-706b-82e2-53f4927eedd6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our fully equipped fitness center features state-of-the-art cardio and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0f8d448-e817-48a2-9de8-e5360b36ee02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-6830-7095-8f16-0d02222aaac5.webp",
      "image_media": {
        "alt_text": "Office reception area with a desk, chairs, and a large window overlooking an outdoor patio.",
        "public_id": "019e1762-6830-7095-8f16-0d02222aaac5",
        "storage_key": "property/6767906449165582/019e1762-6830-7095-8f16-0d02222aaac5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome guests into our stylish leasing office, featuring a modern reception desk, comfortable seating, and a serene view of the community's outdoor patio.",
      "link": "",
      "alt_text": "Office reception area with a desk, chairs, and a large window overlooking an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7bb0d717-b487-4026-92e5-c964e25bb7ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-5ba8-75ce-a5a5-030e7273d912.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, stationary bike, and free weights.",
        "public_id": "019e1762-5ba8-75ce-a5a5-030e7273d912",
        "storage_key": "property/6767906449165582/019e1762-5ba8-75ce-a5a5-030e7273d912.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio machines, free weights, and more.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, stationary bike, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a3e8df9-a5e9-498e-af48-316c8e8a166e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-6f19-777c-af18-cf101f54d7f1.webp",
      "image_media": {
        "alt_text": "Interior view of a well-equipped fitness center with various weight machines and cardio equipment.",
        "public_id": "019e1762-6f19-777c-af18-cf101f54d7f1",
        "storage_key": "property/6767906449165582/019e1762-6f19-777c-af18-cf101f54d7f1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our modern fitness center, featuring a wide selection of state-of-the-art weight and cardio machines for your workout needs.",
      "link": "",
      "alt_text": "Interior view of a well-equipped fitness center with various weight machines and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1be83304-6385-4f07-a721-fbf12fd7767d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Topgolf El Paso",
      "poi_type": "Restaurants",
      "poi_address": "365 Vin Rambla Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Golf-themed entertainment venue combining a driving range with dining and cocktails.",
      "poi_long_description": "People say this restaurant offers fun games, good food, and a variety of drink options. They highlight the lively atmosphere and the friendly, attentive staff. They also like the great party packages and the value, especially on Tuesdays when golfing is half price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b25b-77e7-933a-057b08a21ed0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b25b-77e7-933a-057b08a21ed0",
        "storage_key": "property/6767906449165582/019cfb37-b25b-77e7-933a-057b08a21ed0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://topgolf.com/us/el-paso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10477886874640848166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-el-paso",
      "poi_latitude": "31.8107961",
      "poi_longitude": "-106.5250411",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-845-9028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxkkkflX54YRJhWyJ5nuaJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_de609797-6743-4746-884d-b751be4abe44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "L & J Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3622 E Missouri Ave, El Paso, TX 79903, USA",
      "poi_short_description": "A local landmark dating back to 1927, this family-run eatery serves regional Mexican dishes & beers.",
      "poi_long_description": "People say this Mexican restaurant serves delicious green chile chicken enchiladas, steak tacos, and caldo de res. They highlight the affordable prices, generous portions, and fun, lively atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b1f9-76fb-ab89-b92905777e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b1f9-76fb-ab89-b92905777e62",
        "storage_key": "property/6767906449165582/019cfb37-b1f9-76fb-ab89-b92905777e62.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://ljcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=253529114313290020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l--j-cafe",
      "poi_latitude": "31.7795154",
      "poi_longitude": "-106.4497953",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-566-8418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy58M-oRZ54YRJPHc3mK3hAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_04b4d2dd-6271-4107-95ad-e067a4ede8f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Taconeta",
      "poi_type": "Restaurants",
      "poi_address": "311 Montana Ave A-1, El Paso, TX 79902, USA",
      "poi_short_description": "Laid-back eatery featuring tacos, margaritas and other Mexican fare.",
      "poi_long_description": "People say this taco restaurant serves delicious brisket, chicken, shrimp, and mushroom tacos, as well as elote, fried green beans, and sweet potatoes. They highlight the fresh ingredients, flavorful salsas, and unique take on Mexican food. They also like the friendly and efficient service, and the vibrant, fun atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b29f-76db-9fd1-dd1b130bb001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b29f-76db-9fd1-dd1b130bb001",
        "storage_key": "property/6767906449165582/019cfb37-b29f-76db-9fd1-dd1b130bb001.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.toasttab.com/taconeta",
      "poi_directions_map_url": "https://maps.google.com/?cid=10960950357964817459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taconeta",
      "poi_latitude": "31.7648439",
      "poi_longitude": "-106.4904197",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-303-8038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_NrqhpZ54YRMwQv50YeHZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_946c33f1-cc93-42b7-ba17-3e521eedaf32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Salt + Honey Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1125 Texas Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Casual eatery for coffee & espresso drinks featuring all-day breakfast, brunch and burgers.",
      "poi_long_description": "People say this breakfast restaurant serves delicious chicken and waffles, baklava pancakes, and chilaquiles. They also highlight the attentive and friendly staff, and the vibrant and open dining space.\n\nOther reviews mention the wait time can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b285-74c8-b265-11aaa43441c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b285-74c8-b265-11aaa43441c4",
        "storage_key": "property/6767906449165582/019cfb37-b285-74c8-b265-11aaa43441c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltandhoneyep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866789244147418890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt--honey-bakery-cafe",
      "poi_latitude": "31.7648676",
      "poi_longitude": "-106.4783652",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-313-4907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7y4m5dZ54YRCkcZPghPikM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e7eaf4d9-6493-437d-a94f-012475e7652d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "2201 N Mesa St, El Paso, TX 79902, USA",
      "poi_short_description": "Restaurant chain known for its burgers (including those with jalapenos or green chiles), fries and onion rings, plus shakes.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers. They also highlight the fast and courteous service.\n\nOther reviews mention the drive thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b276-7208-8115-88c6a7233a96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b276-7208-8115-88c6a7233a96",
        "storage_key": "property/6767906449165582/019cfb37-b276-7208-8115-88c6a7233a96.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.whataburger.com/tx/el-paso/2201-n-mesa-st.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=9737941307269630187&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "31.7734029",
      "poi_longitude": "-106.5004915",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-533-8338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9pgYlpY54YR68hobwYeJIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_97aa29ab-d4e1-4a48-8207-15b14236b346",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Pitt St, El Paso, TX 79912, USA",
      "poi_short_description": "Grocery chain including a bakery, an in-store bar and a salad bar.",
      "poi_long_description": "People say this grocery store offers a wide variety of organic foods, fresh produce, and baked goods, including a popular hot bar and pizza. They highlight the clean and modern atmosphere, and the convenient amenities such as a bread slicer and Amazon return area. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b232-7208-a6bd-ed52f2846bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b232-7208-a6bd-ed52f2846bf6",
        "storage_key": "property/6767906449165582/019cfb37-b232-7208-a6bd-ed52f2846bf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/elpaso?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5575333113701639611&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "31.8340462",
      "poi_longitude": "-106.5480013",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-236-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c604-739c-8559-57a3ee1afeb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c604-739c-8559-57a3ee1afeb9",
        "storage_key": "property/6767906449165582/019cfb37-c604-739c-8559-57a3ee1afeb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj13blm_43YYRu6Wocu2PX00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_aa18fee5-d6c7-403b-8057-d96a443c1a2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "The Shoppes at Solana",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "One-time Sunland Park Mall now with a variety of national and local retailers, plus a food court and rock-climbing wall.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a good food court. They also highlight the clean restrooms and fun atmosphere, especially during events like fireworks displays.\n\nOther reviews mention the mall can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b330-740b-9eb2-521909f2732a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b330-740b-9eb2-521909f2732a",
        "storage_key": "property/6767906449165582/019cfb37-b330-740b-9eb2-521909f2732a.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "http://theshoppesatsolana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2107962478139008266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shoppes-at-solana",
      "poi_latitude": "31.8144216",
      "poi_longitude": "-106.5440443",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-833-5596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fd-759e-bc9c-5e318786cc56",
        "storage_key": "property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoWrRgA_43YYRCuVTlbT8QB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_da5e4968-cd4d-405f-8800-7f355b8b438f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7545 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Retailer supplying tools, appliances, building materials, and home improvement items, plus installation services.",
      "poi_long_description": "People say this home improvement store is well-stocked and the staff is helpful and knowledgeable. They also highlight the friendly and attentive service, making it a pleasant shopping experience.\n\nSome reviews mention the wait times for assistance can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b220-766b-9337-1d545bff2a92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b220-766b-9337-1d545bff2a92",
        "storage_key": "property/6767906449165582/019cfb37-b220-766b-9337-1d545bff2a92.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/West-El-Paso/TX/El-Paso/79912/523?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7694583817001495963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.835826",
      "poi_longitude": "-106.5642035",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-585-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fd-759e-bc9c-5e318786cc56",
        "storage_key": "property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8zsx0lv43YYRm-3XwjanyGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_90cb068a-b930-44c5-a4b6-9b4a0674de72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "430 Redd Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Outdoor furniture store, lawn equipment rental service and building materials supplier providing items for home-repair projects.",
      "poi_long_description": "People say this home improvement store offers a wide variety of supplies for home projects. They also highlight the helpfulness of some staff members.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b1fe-74dd-8e58-76432621453c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b1fe-74dd-8e58-76432621453c",
        "storage_key": "property/6767906449165582/019cfb37-b1fe-74dd-8e58-76432621453c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-El-Paso/1152?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1152-_-na-_-0-_-0&y_source=1_MTE4NDM4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5332424068888550467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.861958",
      "poi_longitude": "-106.5726474",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-581-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fd-759e-bc9c-5e318786cc56",
        "storage_key": "property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUewuiOb43YYRQ1zYMXCTAEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_36354960-1098-4a19-b858-3d1d21c501f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Fort Bliss - Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "1611 Haan Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Shopping mall at Freedom Crossing at Fort Bliss with a food court and tax-free bonus savings for military members and veterans.",
      "poi_long_description": "People say this shopping center offers a huge selection of products and services, including a food court with fantastic choices like New York-style pizza. They highlight the clean and well-organized layout, and the friendly and helpful staff. They also like the quick and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b25d-71ec-a5ec-ce2c19aa58f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b25d-71ec-a5ec-ce2c19aa58f5",
        "storage_key": "property/6767906449165582/019cfb37-b25d-71ec-a5ec-ce2c19aa58f5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.shopmyexchange.com/exchange-stores/United%20States/TX/Ft.%20Bliss/Ft-Bliss--1011801",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221724360285077533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss---exchange",
      "poi_latitude": "31.8180883",
      "poi_longitude": "-106.4295632",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-562-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fd-759e-bc9c-5e318786cc56",
        "storage_key": "property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ83LPBZ9Z54YRHcC_Dibc2o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a564dfd9-c289-4168-862a-9cd152673180",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "500 W University Ave, El Paso, TX 79968, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b653-734a-a656-26c14a8db836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b653-734a-a656-26c14a8db836",
        "storage_key": "property/6767906449165582/019cfb37-b653-734a-a656-26c14a8db836.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.utep.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15130569928881990844&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-texas-at-el-paso",
      "poi_latitude": "31.7731979",
      "poi_longitude": "-106.5047208",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-747-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ12KA7lpY54YRvOw3ZC-V-tE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d00ca1f5-33eb-4914-9378-ffbe9f3bdeb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "University Library",
      "poi_type": "Education",
      "poi_address": "1900 Wiggins Rd, El Paso, TX 79968, USA",
      "poi_short_description": "University library with free admission and study space, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b60c-7037-91a8-b265e95993ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b60c-7037-91a8-b265e95993ac",
        "storage_key": "property/6767906449165582/019cfb37-b60c-7037-91a8-b265e95993ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utep.edu/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=16419899299576992938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-library",
      "poi_latitude": "31.7673321",
      "poi_longitude": "-106.50472",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-747-5672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c61a-726f-a546-7798d435cf65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c61a-726f-a546-7798d435cf65",
        "storage_key": "property/6767906449165582/019cfb37-c61a-726f-a546-7798d435cf65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7gl1lhY54YRqtT4pmoz3-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_28db0643-7620-4636-b45d-7c184f4e1ca1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso Community College - Rio Grande Campus - EPCC RG",
      "poi_type": "Education",
      "poi_address": "100 W Rio Grande Ave, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b604-702b-a80a-387b69fea396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b604-702b-a80a-387b69fea396",
        "storage_key": "property/6767906449165582/019cfb37-b604-702b-a80a-387b69fea396.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9387787273262637608&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-community-college---rio-grande-campus---epcc-rg",
      "poi_latitude": "31.763854",
      "poi_longitude": "-106.493823",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4VKH0vhY54YRKKLAUckeSII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_557737f7-3b46-47d0-8a11-f51592e237f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Sun Bowl",
      "poi_type": "Entertainment",
      "poi_address": "2701 Sun Bowl Dr, El Paso, TX 79902, USA",
      "poi_short_description": "Stadium hosting concerts, football games, and Monster Jam events, plus tailgating.",
      "poi_long_description": "People say this stadium hosts a variety of events, including concerts, football games, and Monster Jam. They highlight the beautiful views of the surrounding mountains and the well-maintained facilities, including restrooms and concessions. They also like the spacious seating and the smooth traffic flow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b65f-76eb-adc4-c65da1962f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b65f-76eb-adc4-c65da1962f8e",
        "storage_key": "property/6767906449165582/019cfb37-b65f-76eb-adc4-c65da1962f8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12740333998005602376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sun-bowl",
      "poi_latitude": "31.7733442",
      "poi_longitude": "-106.5079256",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c612-773d-ad7f-6d4e7cf1685d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c612-773d-ad7f-6d4e7cf1685d",
        "storage_key": "property/6767906449165582/019cfb37-c612-773d-ad7f-6d4e7cf1685d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ3x541xY54YRSMj0HkXCzrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_277def08-c314-4737-9494-99753685c7a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Don Haskins Center",
      "poi_type": "Entertainment",
      "poi_address": "151 Glory Rd, El Paso, TX 79902, USA",
      "poi_short_description": "Arena hosting big concerts and other events with food, drink, and free parking.",
      "poi_long_description": "People say this arena is a great place to attend graduations and concerts, and they appreciate the well-organized events and comfortable temperature inside. They also highlight the ample parking and easy access to the venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b63d-7515-b7f0-37cfe59f0a8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b63d-7515-b7f0-37cfe59f0a8b",
        "storage_key": "property/6767906449165582/019cfb37-b63d-7515-b7f0-37cfe59f0a8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/venues/don_haskins_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11992951360778632993&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-haskins-center",
      "poi_latitude": "31.7776195",
      "poi_longitude": "-106.5056719",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-747-5481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46MilERY54YRIX-_o7iFb6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_9b978dff-9a95-425e-a540-acc44da43f15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "Train Station, 4001 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Longstanding facility showcasing 250+ species within habitats, plus playground and cafe.",
      "poi_long_description": "People say this zoo offers a variety of animals, including penguins, sea lions, and giraffes, and has a fun splash pad and playground. They also highlight the affordable price, convenient size for families with young children, and friendly, knowledgeable staff.\n\nOther reviews mention some exhibits can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b7a0-74ab-95a3-8a995582e41d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b7a0-74ab-95a3-8a995582e41d",
        "storage_key": "property/6767906449165582/019cfb37-b7a0-74ab-95a3-8a995582e41d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154948632860338008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-zoo-and-botanical-gardens",
      "poi_latitude": "31.7690489",
      "poi_longitude": "-106.4448897",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-212-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7ASQX5Z54YRWKeWzkbpDH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_83a2e187-6480-4781-a980-f79b320e5493",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Estadio Olímpico Benito Juárez",
      "poi_type": "Entertainment",
      "poi_address": "Av. Heroico Colegio Militar 51, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this stadium offers a variety of events, including concerts and sporting activities, and has ample parking. They highlight the clean restrooms, good security, and acceptable sound quality. They also like the well-maintained track and stands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b68e-7464-aaa1-5f69c9886b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b68e-7464-aaa1-5f69c9886b35",
        "storage_key": "property/6767906449165582/019cfb37-b68e-7464-aaa1-5f69c9886b35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2843042972014026862&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "estadio-olmpico-benito-jurez",
      "poi_latitude": "31.7526757",
      "poi_longitude": "-106.4682618",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+52 656 612 7417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c612-773d-ad7f-6d4e7cf1685d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c612-773d-ad7f-6d4e7cf1685d",
        "storage_key": "property/6767906449165582/019cfb37-c612-773d-ad7f-6d4e7cf1685d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUR_bhxNZ54YRbiARHIWEdCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0d3002a8-c6e9-414e-949e-3195d840d535",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "La Nube STEAM Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "201 W Main Dr, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of interactive exhibits, including a water play area, a climbing structure, and a toddler area, as well as costumes and STEAM activities. They highlight the family-friendly vibe, the educational and entertaining experience, and the clean facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b76e-776a-b23a-1882eb2a3b04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b76e-776a-b23a-1882eb2a3b04",
        "storage_key": "property/6767906449165582/019cfb37-b76e-776a-b23a-1882eb2a3b04.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.la-nube.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5422886930183727470&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-nube-steam-discovery-center",
      "poi_latitude": "31.7590797",
      "poi_longitude": "-106.4906986",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-290-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fc92d66229da",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJTzDNKgBZ54YRbqm1au72QUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_986aba6d-0c1d-4ddd-a4a6-9b07b82b0a88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Kinective Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "Modern gym with state-of-the-art machines, spa amenities and fitness classes, plus personal training.",
      "poi_long_description": "People say this fitness center offers a wide variety of classes, including yoga, Pilates, cycling, and Zumba, as well as state-of-the-art equipment and amenities like a sauna, steam room, and massage chairs. They highlight the positive energy, clean facilities, and convenient features such as a rooftop track, a bar, and a mini restaurant with smoothies, bowls, and salads. They also like the friendly and helpful staff, and the sense of community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b7f1-721e-8a1e-9c24e8c48927.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b7f1-721e-8a1e-9c24e8c48927",
        "storage_key": "property/6767906449165582/019cfb37-b7f1-721e-8a1e-9c24e8c48927.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://kinective.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=844899700064661306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kinective-fitness-club",
      "poi_latitude": "31.8521899",
      "poi_longitude": "-106.5401454",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-260-9895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSrKKj753YYROi8w_cyvuQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_57b01439-c10c-4637-a5ef-a220b4b0508c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5700 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Chain gym with a variety of equipment, tanning, and massage services, plus 24-hour access.",
      "poi_long_description": "People say this gym offers a wide variety of high-quality equipment, including dumbbells and weight machines, and has a spa. They also highlight the clean facilities, spacious showers, and friendly, helpful staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b83b-75bd-b083-f9fe375092f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b83b-75bd-b083-f9fe375092f6",
        "storage_key": "property/6767906449165582/019cfb37-b83b-75bd-b083-f9fe375092f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-mesa-hills-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859376139751605018&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.8241974",
      "poi_longitude": "-106.5208557",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-585-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bh0xehX54YRGkOvrkFmMV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f6d04bc1-8c02-46d7-9301-defa68417fea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "813 Sunland Park Dr Ste B, El Paso, TX 79912, USA",
      "poi_short_description": "Retailer for skin, hair, makeup, and fragrance products, including exclusives, plus in-store salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-b9eb-705d-b116-e02802198270.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-b9eb-705d-b116-e02802198270",
        "storage_key": "property/6767906449165582/019cfb37-b9eb-705d-b116-e02802198270.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/el-paso-tx-303",
      "poi_directions_map_url": "https://maps.google.com/?cid=9506694949814193497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "31.8184478",
      "poi_longitude": "-106.5496002",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-581-0314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL73eNhD43YYRWc2sL7CQ7oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_415144e9-0d5d-4f43-a549-beacdad0f51f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Premium health club offering classes and training sessions in a welcoming atmosphere featuring fitness equipment and a turf area.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and cardio equipment, as well as group classes like Zumba and yoga. They highlight the friendly and helpful staff, and the welcoming and supportive atmosphere. They also like the clean facilities and the availability of amenities such as showers, saunas, and a daycare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-ba5f-774f-a469-7ccc9b0c5dc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-ba5f-774f-a469-7ccc9b0c5dc9",
        "storage_key": "property/6767906449165582/019cfb37-ba5f-774f-a469-7ccc9b0c5dc9.webp",
        "width": 1026,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/el-paso/sunland-mall/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15276080860203553813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs",
      "poi_latitude": "31.8145396",
      "poi_longitude": "-106.5462017",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-300-1993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1_VFxT53YYRFZSTMJuK_9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_201351b2-4e3c-476d-a4ce-7d94c123ebb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6910 N Mesa St Ste H Suite D, El Paso, TX 79912, USA",
      "poi_short_description": "Gymnastics center with USA Gymnastics-certified coaches offering classes for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-ba6f-743c-a689-b74ef5aa4671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-ba6f-743c-a689-b74ef5aa4671",
        "storage_key": "property/6767906449165582/019cfb37-ba6f-743c-a689-b74ef5aa4671.webp",
        "width": 1008,
        "height": 567
      },
      "poi_business_url": "https://elpasogymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1102495125243281967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-gymnastics",
      "poi_latitude": "31.8356392",
      "poi_longitude": "-106.5482103",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-581-3476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg6HzWWX43YYRL8K5onnZTA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4e26d182-f691-40fb-b033-7ed501223648",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "981 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Gym chain with free weights and cardio machines, plus group fitness classes and saunas.",
      "poi_long_description": "People say this fitness center offers a decent amount of equipment and has friendly staff.\n\nOther reviews mention the bathrooms can be outdated and the equipment can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-baef-713f-b804-c9f350b4fed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-baef-713f-b804-c9f350b4fed9",
        "storage_key": "property/6767906449165582/019cfb37-baef-713f-b804-c9f350b4fed9.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-resler/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7817928767867659509&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.86318139999999",
      "poi_longitude": "-106.5590516",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-760-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99A4Bwz53YYR9SQPEMvcfmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_07433cb6-a7ed-42f8-b3b0-9cc1733e84c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso Animal Urgent Care West",
      "poi_type": "Health and Wellness",
      "poi_address": "5500 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-babb-7794-a646-65a5bd92492a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-babb-7794-a646-65a5bd92492a",
        "storage_key": "property/6767906449165582/019cfb37-babb-7794-a646-65a5bd92492a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://elpasoanimalurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8021225143916288949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-animal-urgent-care-west",
      "poi_latitude": "31.8592417",
      "poi_longitude": "-106.575303",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-301-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-crCu353YYRtduPJsUdUW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_34785b75-8cf7-4b72-b5b5-6faad93e3abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Gimnasio Municipal Josué Neri Santos",
      "poi_type": "Health and Wellness",
      "poi_address": "Prof.ª María Martínez s/n, Centro, 32000 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-bb05-775d-b43b-d36448d76623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-bb05-775d-b43b-d36448d76623",
        "storage_key": "property/6767906449165582/019cfb37-bb05-775d-b43b-d36448d76623.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4476679980438114226&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gimnasio-municipal-josu-neri-santos",
      "poi_latitude": "31.741728",
      "poi_longitude": "-106.4869251",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+52 656 239 5774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6cfhiBZ54YRss8dR7lcID4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_378299a8-3737-48e2-bac0-2b96e81e0d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Las Palmas Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 N Oregon St, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-bb8a-716b-a4d5-6494357cf956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-bb8a-716b-a4d5-6494357cf956",
        "storage_key": "property/6767906449165582/019cfb37-bb8a-716b-a4d5-6494357cf956.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://laspalmasdelsolhealthcare.com/locations/las-palmas-medical-center/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7797277200056017172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-palmas-medical-center",
      "poi_latitude": "31.7699653",
      "poi_longitude": "-106.4987868",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-521-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c614-77cd-9fdd-aaaaad02ba7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c614-77cd-9fdd-aaaaad02ba7e",
        "storage_key": "property/6767906449165582/019cfb37-c614-77cd-9fdd-aaaaad02ba7e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3k-QVdY54YRFGGXPE1-NWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7c59ac0d-1a1a-41d3-9418-b7fbb7e681ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "The Hospitals of Providence Memorial Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2001 N Oregon St, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-bc11-72df-960f-a4a0f7f0c18c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-bc11-72df-960f-a4a0f7f0c18c",
        "storage_key": "property/6767906449165582/019cfb37-bc11-72df-960f-a4a0f7f0c18c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thehospitalsofprovidence.com/locations/detail/memorial-campus/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-thop-memorial-campus&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=169003115199027928&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-hospitals-of-providence-memorial-campus",
      "poi_latitude": "31.7699593",
      "poi_longitude": "-106.5007533",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-577-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c614-77cd-9fdd-aaaaad02ba7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c614-77cd-9fdd-aaaaad02ba7e",
        "storage_key": "property/6767906449165582/019cfb37-c614-77cd-9fdd-aaaaad02ba7e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6gG81lY54YR2FpfF3BrWAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3cb82be1-a918-4ac4-aab4-14c5806bc39d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Tom Mays Park Access Rd, El Paso, TX 79911, USA",
      "poi_short_description": "Vast state park featuring caves to explore, mountain trails and an amphitheater.",
      "poi_long_description": "People say this state park offers well-maintained hiking trails with breathtaking views, and opportunities for bird watching, picnicking, and camping. They highlight the easy and quick payment process for fees and parking, and the availability of picnic areas. They also like the friendly and helpful staff at the visitor center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-bc4b-72f2-a631-3bc6a5d50671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-bc4b-72f2-a631-3bc6a5d50671",
        "storage_key": "property/6767906449165582/019cfb37-bc4b-72f2-a631-3bc6a5d50671.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/franklin-mountains",
      "poi_directions_map_url": "https://maps.google.com/?cid=2199656840794880227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.9105609",
      "poi_longitude": "-106.518116",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 915-444-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-087dd02e3d1d",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc0ThtdV54YR4zhWDz7Ahh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_a7cdbca6-5cc9-41e2-8a3f-68b8ab177d20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Park featuring hills and shaded areas, an ice-cream truck, a playground and tennis courts for activities like walking and picnics.",
      "poi_long_description": "People say this city park offers plenty of grass for picnics and games, a playground, and shade from numerous trees. They highlight the peaceful and relaxing vibe, and the well-maintained grounds. They also like the nearby ice cream truck and library branch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-bca6-7285-8212-f319cefdfbc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-bca6-7285-8212-f319cefdfbc8",
        "storage_key": "property/6767906449165582/019cfb37-bca6-7285-8212-f319cefdfbc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-087dd02e3d1d",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_de66f4df-912b-4b5b-921c-fb4c4ce62942",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Parque Público Federal El Chamizal",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Ing. David Herrera, C. Malecón, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "Ceded by the US to Mexico in 1963, this green space is now a public park for sports & recreation.",
      "poi_long_description": "People say this park offers green areas, a museum, and opportunities for picnics, running, and outdoor sports. They highlight the tranquil and relaxing vibe, and the spacious areas suitable for family gatherings and activities. They also like the well-maintained grounds and the opportunity to interact with squirrels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-be5c-7448-bae9-2a907ee18097.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-be5c-7448-bae9-2a907ee18097",
        "storage_key": "property/6767906449165582/019cfb37-be5c-7448-bae9-2a907ee18097.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16119446820157355735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parque-pblico-federal-el-chamizal",
      "poi_latitude": "31.7554974",
      "poi_longitude": "-106.4596892",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-087dd02e3d1d",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9BqGmxZ54YR13ZHe3rHs98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2c4537d5-63e2-49e7-a4e9-d3618631d65d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "DIF Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Av. Heroico Colegio Militar s/n, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-bec5-73ea-9301-a883c74548ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-bec5-73ea-9301-a883c74548ce",
        "storage_key": "property/6767906449165582/019cfb37-bec5-73ea-9301-a883c74548ce.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5530219233310207241&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dif-park",
      "poi_latitude": "31.7514945",
      "poi_longitude": "-106.4652985",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-087dd02e3d1d",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVfTwxRZ54YRCe18oxdJv0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_93a75bf6-97a6-4811-b47f-36e36c766e3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso Municipal Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3418 Aurora Ave, El Paso, TX 79930, USA",
      "poi_short_description": "Peaceful oasis featuring different varieties of roses and other flowers, with benches and a fountain.",
      "poi_long_description": "People say this garden offers a wide variety of beautiful roses and other flowers. They highlight the peaceful and serene atmosphere, perfect for walking, sitting, and meditation. They also like the well-maintained pathways and shaded seating areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-beee-732b-aded-4fc35cfddb68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-beee-732b-aded-4fc35cfddb68",
        "storage_key": "property/6767906449165582/019cfb37-beee-732b-aded-4fc35cfddb68.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16475470708097522831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-municipal-rose-garden",
      "poi_latitude": "31.7928257",
      "poi_longitude": "-106.4530369",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-087dd02e3d1d",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT37fuJJZ54YRj5yBd1GhpOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_d1f85161-cd61-4163-b880-51fa9f5f3786",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W San Francisco Ave, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-befa-776b-9bff-3b65cc4ba599.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-befa-776b-9bff-3b65cc4ba599",
        "storage_key": "property/6767906449165582/019cfb37-befa-776b-9bff-3b65cc4ba599.webp",
        "width": 1280,
        "height": 818
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ELP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091980658630256344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso",
      "poi_latitude": "31.7573824",
      "poi_longitude": "-106.4959039",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c8e3-7328-8d8e-2bea75702669.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c8e3-7328-8d8e-2bea75702669",
        "storage_key": "property/6767906449165582/019cfb37-c8e3-7328-8d8e-2bea75702669.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8VMdftY54YR2OaAEdrpMu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_7a4e8a53-8652-4fff-bdb5-6c07033ef69b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Campbell St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c007-7269-ada6-c0d750444aa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-c007-7269-ada6-c0d750444aa6",
        "storage_key": "property/6767906449165582/019cfb37-c007-7269-ada6-c0d750444aa6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7004826674061616697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-city-hall",
      "poi_latitude": "31.7618251",
      "poi_longitude": "-106.4853072",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-212-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c61a-726f-a546-7798d435cf65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c61a-726f-a546-7798d435cf65",
        "storage_key": "property/6767906449165582/019cfb37-c61a-726f-a546-7798d435cf65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8RKcPxY54YROaafNL8kNmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a6e536e0-7e66-49ac-9c59-a8c42cf493ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "WestStar Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 N Mesa St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c007-7269-ada6-bd72e4f527f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-c007-7269-ada6-bd72e4f527f3",
        "storage_key": "property/6767906449165582/019cfb37-c007-7269-ada6-bd72e4f527f3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.weststartower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17936696281012297070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "weststar-tower",
      "poi_latitude": "31.7619103",
      "poi_longitude": "-106.4902384",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-532-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0X5dzG9Z54YRbt3OITzy6_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_013be3d3-c092-476c-8eaa-1f34948b2d62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "1 Civic Center Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Civic Center Plaza, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c08f-72df-99b1-4fbf3506e2fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-c08f-72df-99b1-4fbf3506e2fa",
        "storage_key": "property/6767906449165582/019cfb37-c08f-72df-99b1-4fbf3506e2fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12352449684385399443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "1-civic-center-plaza",
      "poi_latitude": "31.7576845",
      "poi_longitude": "-106.4917571",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVV8fxY54YRk4Ktt4q3bKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_410bfda1-9327-4209-adb9-72f4894e3232",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "TransPerfect Connect",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1015 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c0de-7664-ad30-62b18282aa79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-c0de-7664-ad30-62b18282aa79",
        "storage_key": "property/6767906449165582/019cfb37-c0de-7664-ad30-62b18282aa79.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.transperfectconnect.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17503557915821498174&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "transperfect-connect",
      "poi_latitude": "31.8540386",
      "poi_longitude": "-106.5409878",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-289-9425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGydw0WT53YYRPl8Exi8h6fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5c8f4edd-1791-4fce-ba45-8d7b9dd2eda1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "5th Armored Brigade",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1002 Pleasonton Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c1b7-765b-a4d3-9497d3159a22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb37-c1b7-765b-a4d3-9497d3159a22",
        "storage_key": "property/6767906449165582/019cfb37-c1b7-765b-a4d3-9497d3159a22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14958475088164677305&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "5th-armored-brigade",
      "poi_latitude": "31.808054",
      "poi_longitude": "-106.426845",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8cTJxBa54YRueaV29Ytl88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0bd4426e-4e15-4f88-9ae0-c48bc0a86407",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Radford School",
      "poi_type": "Education",
      "poi_address": "2001 Radford St, El Paso, TX 79903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-ab4d-72ad-8e81-6afc33a9dc05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ab4d-72ad-8e81-6afc33a9dc05",
        "storage_key": "property/6767906449165582/019d7911-ab4d-72ad-8e81-6afc33a9dc05.webp",
        "width": 1280,
        "height": 487
      },
      "poi_business_url": "http://radfordschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2381812476849719573&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "radford-school",
      "poi_latitude": "31.7948938",
      "poi_longitude": "-106.4382677",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-565-2737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ57w5KSBa54YRFYk4DNTlDSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1fc16025-aef7-4521-bacc-189964d525b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Loretto Academy",
      "poi_type": "Education",
      "poi_address": "1300 Hardaway St, El Paso, TX 79903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-ab79-7679-b395-c06aa8a45d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ab79-7679-b395-c06aa8a45d5e",
        "storage_key": "property/6767906449165582/019d7911-ab79-7679-b395-c06aa8a45d5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.loretto.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17004542786702523310&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "loretto-academy",
      "poi_latitude": "31.7871529",
      "poi_longitude": "-106.4341918",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-566-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLSw8bSZa54YRrrtVEZJF_Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e17ee969-5568-4e00-934d-a2005cbb1d1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Dr. Green Elementary School",
      "poi_type": "Education",
      "poi_address": "5430 Buckley Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-a994-75f3-b718-ee496a181bd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-a994-75f3-b718-ee496a181bd6",
        "storage_key": "property/6767906449165582/019d7911-a994-75f3-b718-ee496a181bd6.webp",
        "width": 1280,
        "height": 507
      },
      "poi_business_url": "https://www.episd.org/o/gres",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283601174716929722&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dr-green-elementary-school",
      "poi_latitude": "31.822663",
      "poi_longitude": "-106.511893",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-236-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF_WoxuxX54YRutaGKrKv2-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9956e141-3cab-4669-b1b6-cd98a95b27b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Hornedo Middle School",
      "poi_type": "Education",
      "poi_address": "6101 High Ridge Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-a87f-73ab-8ddd-a2bf5cf6e3a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-a87f-73ab-8ddd-a2bf5cf6e3a7",
        "storage_key": "property/6767906449165582/019d7911-a87f-73ab-8ddd-a2bf5cf6e3a7.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.episd.org/hornedo",
      "poi_directions_map_url": "https://maps.google.com/?cid=7710372300509239893&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hornedo-middle-school",
      "poi_latitude": "31.8707115",
      "poi_longitude": "-106.5226258",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-236-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIyZZd5T43YYRVVrdicG-AGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7374c832-91a3-4e6a-ada3-645ca14d8f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Cathedral High School",
      "poi_type": "Education",
      "poi_address": "1309 N Stanton St, El Paso, TX 79902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cathedral-elpaso.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12835278170215193353&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cathedral-high-school",
      "poi_latitude": "31.7675029",
      "poi_longitude": "-106.4939007",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-532-3238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKxUl4FVY54YRCZsA2X0RILI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_cd961146-96d6-4d84-a844-ee21d3be1665",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Northwest Early College High School",
      "poi_type": "Education",
      "poi_address": "6701 S Desert Blvd, El Paso, TX 79932, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nwechs.canutillo-isd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14932058760065977149&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwest-early-college-high-school",
      "poi_latitude": "31.9013526",
      "poi_longitude": "-106.5863037",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-877-1701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5f6-769f-a9f3-d8d9b9f066b3",
        "storage_key": "property/6767906449165582/019cfb37-c5f6-769f-a9f3-d8d9b9f066b3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafRKQtj-3YYRPQv-LlRUOc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8f18dbd2-2226-4e0a-aab0-914934396b86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "The Holy Grail",
      "poi_type": "Restaurants",
      "poi_address": "5860 N Mesa St suite 129-131, El Paso, TX 79912, USA",
      "poi_short_description": "Friendly restaurant serving Italian dishes, along with wines and cocktails, in a cozy ambiance.",
      "poi_long_description": "Diners say this restaurant serves up delicious fish and chips, French onion soup, and pasta. They also highlight the friendly and attentive staff, and the lively yet relaxed atmosphere with great music.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-b3f1-741d-ae67-0981607b43ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b3f1-741d-ae67-0981607b43ac",
        "storage_key": "property/6767906449165582/019d7911-b3f1-741d-ae67-0981607b43ac.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.theholygrailtogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7557070361962034347&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-holy-grail",
      "poi_latitude": "31.8264933",
      "poi_longitude": "-106.5238367",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-303-8045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb4JO2ldX54YRqzRhg3Qb4Gg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1e0158ca-81a2-476a-b74c-52aacbdc48f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Entrecôte & Co.",
      "poi_type": "Restaurants",
      "poi_address": "5825 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Upscale steakhouse serving French fare, plus wine, cocktails and beer in a cozy setting.",
      "poi_long_description": "People say this restaurant serves delicious French cuisine, including escargot, Chilean sea bass, and steak. They highlight the attentive and friendly staff, and the upscale yet relaxed atmosphere. They also like the great wine selection and the complimentary champagne and cake for special occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-b452-734e-8cbc-f7e1e4bb0de5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b452-734e-8cbc-f7e1e4bb0de5",
        "storage_key": "property/6767906449165582/019d7911-b452-734e-8cbc-f7e1e4bb0de5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://entrecotebistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14255218939255702019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "entrec-te-co",
      "poi_latitude": "31.8247658",
      "poi_longitude": "-106.524366",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-300-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-qvu3pX54YRA8LBDRm21MU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_38d72a72-58e6-4d88-82eb-bcf7af974c0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Pelican's Steak & Seafood",
      "poi_type": "Restaurants",
      "poi_address": "130 Shadow Mountain Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Relaxed mainstay serving rib-eye, lobster & bottomless salads along with tropical drinks & martinis.",
      "poi_long_description": "People say this seafood restaurant serves delicious steaks, seafood, and prime rib, with highlights including the grilled artichoke, wedge salad, and fish of the day. They highlight the comfortable and welcoming atmosphere, ideal for both relaxed dinners and special occasions. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-b36b-77e6-b97a-e8c55712c99c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b36b-77e6-b97a-e8c55712c99c",
        "storage_key": "property/6767906449165582/019d7911-b36b-77e6-b97a-e8c55712c99c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://pelicans-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=816365703816841503&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pelican-s-steak-seafood",
      "poi_latitude": "31.8296244",
      "poi_longitude": "-106.5261266",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-581-1392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcITn91X54YRH4nQRkhQVAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_def60579-c2b9-4dea-9312-f993d6f3b8fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Koze Teppan Grill",
      "poi_type": "Restaurants",
      "poi_address": "6127 N Mesa St B, El Paso, TX 79912, USA",
      "poi_short_description": "Chefs grill meats & veggies tableside at this lively Japanese spot also offering sushi & cocktails.",
      "poi_long_description": "Diners say this bar and grill offers great portion sizes and delicious food, including the Bento box and New York steak with shrimp. They also highlight the reasonable prices, especially compared to other local establishments.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-b800-7482-a81f-0e8b6bc0a223.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b800-7482-a81f-0e8b6bc0a223",
        "storage_key": "property/6767906449165582/019d7911-b800-7482-a81f-0e8b6bc0a223.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kozeteppangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5815450502152114703&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "koze-teppan-grill",
      "poi_latitude": "31.8308127",
      "poi_longitude": "-106.5322486",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-584-1128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7912-0fc4-77ba-b71c-038bbb607aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-0fc4-77ba-b71c-038bbb607aef",
        "storage_key": "property/6767906449165582/019d7912-0fc4-77ba-b71c-038bbb607aef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_5VHt9X54YRD9KkjWuhtFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_2b45b09a-a985-4541-bd30-22718a198968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Garufa Restaurante Argentino - Cd. Juárez",
      "poi_type": "Restaurants",
      "poi_address": "Bulevar Tomás Fernández 7671, Los Cisnes, Col Los Parques, 32440 Juárez, Chih., Mexico",
      "poi_short_description": "false",
      "poi_long_description": "People say this Argentinian restaurant serves delicious grilled meats, empanadas, and mollejas. They also highlight the relaxing and sophisticated atmosphere, and the attentive and professional service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-bc35-76bf-b8e2-9c4ce232b705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bc35-76bf-b8e2-9c4ce232b705",
        "storage_key": "property/6767906449165582/019d7911-bc35-76bf-b8e2-9c4ce232b705.webp",
        "width": 1080,
        "height": 864
      },
      "poi_business_url": "http://www.garufajuarez.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8686012625733464008&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garufa-restaurante-argentino-cd-ju-rez",
      "poi_latitude": "31.7319761",
      "poi_longitude": "-106.4117989",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+52 656 625 9772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxsj-3Vc54YRyK9mb3bqing",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "argentinian_restaurant"
    },
    {
      "id": "custom_2f18cc18-1c8f-45ff-824e-3827a7461856",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Umami Ramen House",
      "poi_type": "Restaurants",
      "poi_address": "5380 N Mesa St #110, El Paso, TX 79912, USA",
      "poi_short_description": "Asian eatery known for a wide variety of ramen styles, plus classics like orange chicken and fried rice.",
      "poi_long_description": "People say this ramen restaurant serves delicious ramen, fried dumplings, and pork buns. They also highlight the generous portions, reasonable prices, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-c49c-74f1-9fdb-b541c6aa27a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c49c-74f1-9fdb-b541c6aa27a3",
        "storage_key": "property/6767906449165582/019d7911-c49c-74f1-9fdb-b541c6aa27a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://umamiramenhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3232489545793798385&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "umami-ramen-house",
      "poi_latitude": "31.8180228",
      "poi_longitude": "-106.5146855",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-304-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaX2WNNX54YR8QA0jR0c3Cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_b88fb84c-9fb5-4ef6-9f09-0b2ba0e6cf2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Thyme Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5857 N Mesa St #24, El Paso, TX 79912, USA",
      "poi_short_description": "Eclectic New American dishes & cocktails in an elegant space with a mezzanine & patio.",
      "poi_long_description": "People say this New American restaurant serves delicious food, including scallops, duck, and beef medallions. They highlight the sophisticated atmosphere, extensive wine cellar, and attentive staff. They also like the friendly and professional service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-c6c8-765c-afad-437125422cca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c6c8-765c-afad-437125422cca",
        "storage_key": "property/6767906449165582/019d7911-c6c8-765c-afad-437125422cca.webp",
        "width": 709,
        "height": 870
      },
      "poi_business_url": "https://www.thymerestaurantep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10626591408354507174&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thyme-restaurant",
      "poi_latitude": "31.826515",
      "poi_longitude": "-106.526716",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-585-0309",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHY9VcedX54YRpjkwdJU8eZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3fc598a4-0dfe-4329-b94e-cfeec7ac428c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "7829 N Mesa St, El Paso, TX 79932, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop offers great coffee and excellent customer service. They also highlight the attentive and kind staff who go out of their way to help customers, even during busy periods.\n\nSome reviews mention the water policy can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-c908-71ae-85a0-aee496423aae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c908-71ae-85a0-aee496423aae",
        "storage_key": "property/6767906449165582/019d7911-c908-71ae-85a0-aee496423aae.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/10223/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4928995477168906213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "31.83941999999999",
      "poi_longitude": "-106.57246",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-231-9673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7912-0fe9-731d-bd43-0a93e2aa0101.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-0fe9-731d-bd43-0a93e2aa0101",
        "storage_key": "property/6767906449165582/019d7912-0fe9-731d-bd43-0a93e2aa0101.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJrTtHJVf43YYR5d8ohEVPZ0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_757dd6f9-7ee7-43a2-a90a-e7743014c482",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Peter Piper Pizza",
      "poi_type": "Restaurants",
      "poi_address": "119 Balboa Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Lively, kid-oriented chain featuring pizza & wings along with dozens of arcade games.",
      "poi_long_description": "Lively, kid-oriented chain featuring pizza & wings along with dozens of arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-c6b8-7228-a4fc-8efbe3b47d41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c6b8-7228-a4fc-8efbe3b47d41",
        "storage_key": "property/6767906449165582/019d7911-c6b8-7228-a4fc-8efbe3b47d41.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://locations.peterpiperpizza.com/tx/elpaso/119-n-balboa-rd?utm_source=Google&utm_medium=Rio",
      "poi_directions_map_url": "https://maps.google.com/?cid=9351037358451774507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peter-piper-pizza",
      "poi_latitude": "31.8313484",
      "poi_longitude": "-106.5297732",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-581-4423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fbd04495846e",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fbd04495846e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zJadN5X54YRK9Ts_-6OxYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_6a651ead-a5bd-4a4f-9c37-31b224891f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Restaurants",
      "poi_address": "655 Sunland Park Dr Ste B, El Paso, TX 79912, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic options, snacks, and unique items not found in other stores. They highlight the clean and well-organized layout, and the fair prices, especially during sales. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-cf6c-72d0-bab4-8782c4f8031e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cf6c-72d0-bab4-8782c4f8031e",
        "storage_key": "property/6767906449165582/019d7911-cf6c-72d0-bab4-8782c4f8031e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/tx/el-paso/el-paso",
      "poi_directions_map_url": "https://maps.google.com/?cid=6636959221749597832&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "31.82128599999999",
      "poi_longitude": "-106.5447502",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-833-3380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c604-739c-8559-57a3ee1afeb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c604-739c-8559-57a3ee1afeb9",
        "storage_key": "property/6767906449165582/019cfb37-c604-739c-8559-57a3ee1afeb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5467d5X54YRiEYjgT83G1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1346d760-756a-4d48-ae1f-7b7a63ce3ce5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Coronado Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "5905 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-d58a-7166-a454-47f7d92fa8d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d58a-7166-a454-47f7d92fa8d3",
        "storage_key": "property/6767906449165582/019d7911-d58a-7166-a454-47f7d92fa8d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12549446340279395017&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coronado-shopping-center",
      "poi_latitude": "31.8289035",
      "poi_longitude": "-106.5285746",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fd-759e-bc9c-5e318786cc56",
        "storage_key": "property/6767906449165582/019cfb37-c5fd-759e-bc9c-5e318786cc56.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIxU5QEtX54YRyeIt6PSWKK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6ca6400e-77b4-4894-aa33-1bcfb05c38ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "801 S Mesa Hills Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, obstacle courses, and laser tag. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-d8b9-74d3-8242-ce1d05c036cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d8b9-74d3-8242-ce1d05c036cf",
        "storage_key": "property/6767906449165582/019d7911-d8b9-74d3-8242-ce1d05c036cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/texas-west-el-paso/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9791591556466300534&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "31.81827539999999",
      "poi_longitude": "-106.5405754",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-263-8277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2yyOdb53YYRdlbjfKS44oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_4b10b34e-db23-4581-b60d-2c4399847287",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "McKelligon Canyon",
      "poi_type": "Entertainment",
      "poi_address": "McKelligon Canyon Rd, El Paso, TX 79930, USA",
      "poi_short_description": "Shaded picnic tables and a cave at this desert park featuring trails, an amphitheater and a show.",
      "poi_long_description": "People say this amphitheatre offers a cool place to watch concerts, with good food and drinks. They highlight the beautiful mountain and city views, and the relaxing and quiet vibe. They also like the challenging hills for hiking and training, and the easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-e2ab-75f8-8508-b0ad25f4a9da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e2ab-75f8-8508-b0ad25f4a9da",
        "storage_key": "property/6767906449165582/019d7911-e2ab-75f8-8508-b0ad25f4a9da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://elpasolive.com/venues/mckelligon-canyon-amphitheatre",
      "poi_directions_map_url": "https://maps.google.com/?cid=17692196788310998967&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mckelligon-canyon",
      "poi_latitude": "31.8375278",
      "poi_longitude": "-106.4846943",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 915-534-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeBU7mZX54YRt3-V3z1Ph_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_40b7fce1-14c9-473d-a29b-7a151fa4c061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Thousand Steps Trailhead",
      "poi_type": "Entertainment",
      "poi_address": "4999 N Stanton St, El Paso, TX 79902, USA",
      "poi_short_description": "Popular trail featuring rocky terrain, caves and views of El Paso, plus airplane wreckage.",
      "poi_long_description": "People say this hiking area offers beautiful views and a variety of trails suitable for different skill levels. They highlight the trails are dog-friendly, and the trailhead is well-equipped with amenities such as a water fountain, picnic tables, and tools for bicyclists. They also like the convenient access and the honor box payment system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-e562-77ed-99ea-c6859a4a4d3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e562-77ed-99ea-c6859a4a4d3d",
        "storage_key": "property/6767906449165582/019d7911-e562-77ed-99ea-c6859a4a4d3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks/parks-planning/trails-and-trailheads/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5674331233262067202&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thousand-steps-trailhead",
      "poi_latitude": "31.8077772",
      "poi_longitude": "-106.5000008",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0eF2ydY54YRAl59WDFGv04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_2f5fd1c9-df42-4230-bb34-74e1754f2771",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Centennial Museum and Chihuahuan Desert Gardens",
      "poi_type": "Entertainment",
      "poi_address": "500 W University Ave, El Paso, TX 79968, USA",
      "poi_short_description": "Jumbo garden with walking paths offering various areas featuring over 600 native plants.",
      "poi_long_description": "People say this museum offers informational exhibits about different species and historical events, and allows visitors to see these species through the gardens. They highlight the beautiful blooms and the opportunity to touch a dinosaur bone. They also like the helpful and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-e394-74a3-a5b9-748866dacd3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e394-74a3-a5b9-748866dacd3f",
        "storage_key": "property/6767906449165582/019d7911-e394-74a3-a5b9-748866dacd3f.webp",
        "width": 1055,
        "height": 716
      },
      "poi_business_url": "https://www.utep.edu/centennial-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12340300450534377034&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "centennial-museum-and-chihuahuan-desert-gardens",
      "poi_latitude": "31.7692881",
      "poi_longitude": "-106.5059544",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-747-5565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fc92d66229da",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWXhOpV5Y54YRSsaxx-CNQas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_980981fb-87ee-4aa2-a829-7932dd181bac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso Museum of Archaeology",
      "poi_type": "Entertainment",
      "poi_address": "4301 Woodrow Bean Transmountain Dr, El Paso, TX 79924, USA",
      "poi_short_description": "Museum featuring exhibits on the ancient history of the Southwest & northern Mexico, plus a garden.",
      "poi_long_description": "Visitors say this museum offers a wealth of information about the history and culture of El Paso, as well as the indigenous history of the area, and features a lovely nature trail in the shadow of the Franklin Mountains. They also highlight the museum's free admission, family-friendly atmosphere, and well-done events with kind vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-ec49-731b-84db-196922a54e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ec49-731b-84db-196922a54e34",
        "storage_key": "property/6767906449165582/019d7911-ec49-731b-84db-196922a54e34.webp",
        "width": 1200,
        "height": 650
      },
      "poi_business_url": "http://epmarch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8265411461810075806&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-museum-of-archaeology",
      "poi_latitude": "31.9036702",
      "poi_longitude": "-106.4490514",
      "poi_miles_from_property": "19.1 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 915-212-0421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fc92d66229da",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUoxMmZR54YRnriht-6jtHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2d607827-212b-439c-af0c-dfd82ad10f6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Wyler Aerial Tramway",
      "poi_type": "Entertainment",
      "poi_address": "1700 McKinley Ave, El Paso, TX 79930, USA",
      "poi_short_description": "Gondolas traveling to and from Ranger Peak plus a gift shop, restrooms & viewing platforms.",
      "poi_long_description": "Gondolas traveling to and from Ranger Peak plus a gift shop, restrooms & viewing platforms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-f400-76db-a905-f4e322f672fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f400-76db-a905-f4e322f672fc",
        "storage_key": "property/6767906449165582/019d7911-f400-76db-a905-f4e322f672fc.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/wyler-aerial-tramway",
      "poi_directions_map_url": "https://maps.google.com/?cid=10702077498266787339&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wyler-aerial-tramway",
      "poi_latitude": "31.8093698",
      "poi_longitude": "-106.4783946",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 915-566-6622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-087dd02e3d1d",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-087dd02e3d1d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVEfBtdZ54YRC57kWshqhZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_699753f6-61bf-408e-8d71-f4624bd08098",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "El Paso Country Club",
      "poi_type": "Entertainment",
      "poi_address": "5000 Country Club Pl, El Paso, TX 79922, USA",
      "poi_short_description": "Established in 1906, this well-regarded club offers a golf course, tennis facilities, a pool, and dining.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-f850-77bb-ae5a-5e7d16a85a75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f850-77bb-ae5a-5e7d16a85a75",
        "storage_key": "property/6767906449165582/019d7911-f850-77bb-ae5a-5e7d16a85a75.webp",
        "width": 1280,
        "height": 877
      },
      "poi_business_url": "http://www.elpasocountryclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12208712840127815853&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-country-club",
      "poi_latitude": "31.8365894",
      "poi_longitude": "-106.5914513",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-584-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCamr1Kj53YYRraCRwKQPbqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_3b32a069-525c-470c-a5db-7807c01b4958",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Bob-O's Family Fun Center",
      "poi_type": "Entertainment",
      "poi_address": "3851 Constitution Dr, El Paso, TX 79922, USA",
      "poi_short_description": "Amusement venue with laser tag, go-karts, bumper boats, batting cages, an arcade, snacks & more.",
      "poi_long_description": "People say this amusement center offers a variety of fun activities, including go-karts, bumper boats, laser tag, and arcade games. They also highlight the reasonable prices and friendly, accommodating staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7911-f9df-7449-8eb3-6b20bc5198fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f9df-7449-8eb3-6b20bc5198fd",
        "storage_key": "property/6767906449165582/019d7911-f9df-7449-8eb3-6b20bc5198fd.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://bobosfun.com/?utm_source=gmb&utm_medium=organic&utm_campaign=elpaso",
      "poi_directions_map_url": "https://maps.google.com/?cid=18166085088815833051&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bob-o-s-family-fun-center",
      "poi_latitude": "31.8126125",
      "poi_longitude": "-106.5540313",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-587-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-acwxn43YYR219j5iPmGvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_9a4bfc75-be1b-4817-a27d-f8d5d779f188",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Wigwam Museum",
      "poi_type": "Entertainment",
      "poi_address": "110 E San Antonio Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Originally a saloon in 1883, this museum offers history exhibits, ghost tours, art shows & events.",
      "poi_long_description": "Originally a saloon in 1883, this museum offers history exhibits, ghost tours, art shows & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7912-0435-7518-948d-7384b3f59bd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0435-7518-948d-7384b3f59bd3",
        "storage_key": "property/6767906449165582/019d7912-0435-7518-948d-7384b3f59bd3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ghosts915.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11397940602288268348&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wigwam-museum",
      "poi_latitude": "31.7578173",
      "poi_longitude": "-106.4883395",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-274-9531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c5fc-77fb-8067-fc92d66229da",
        "storage_key": "property/6767906449165582/019cfb37-c5fc-77fb-8067-fc92d66229da.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJh08bZf1Y54YRPORkwpaeLZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_34c8a579-a981-4d46-9dad-e2e179469991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Ascarate Park Pool & Aquatics",
      "poi_type": "Entertainment",
      "poi_address": "6900 Delta Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Huge outdoor public pool open seasonally for swimming, diving, and chilling.",
      "poi_long_description": "People say this outdoor swimming pool offers a large pool with varying depths, a children's pool, and a ninja warrior course. They also highlight the park's all-abilities park, sitting areas, and opportunities for fishing and picnicking.\n\nOther reviews mention the hours can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019d7912-017e-77ed-9978-52ba4ec20911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-017e-77ed-9978-52ba4ec20911",
        "storage_key": "property/6767906449165582/019d7912-017e-77ed-9978-52ba4ec20911.webp",
        "width": 1280,
        "height": 515
      },
      "poi_business_url": "https://www.epcountyparks.com/ascarate-pool",
      "poi_directions_map_url": "https://maps.google.com/?cid=12124686360001813446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ascarate-park-pool-aquatics",
      "poi_latitude": "31.7558416",
      "poi_longitude": "-106.4040658",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-273-3501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb37-c615-75ec-9ba6-0c80bd5e4274",
        "storage_key": "property/6767906449165582/019cfb37-c615-75ec-9ba6-0c80bd5e4274.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrU2-oKJb54YRxpvuTAGKQ6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_02a6c581-cdbb-49eb-94ad-baae7cbcfa8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Lyndon B. Johnson Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "lyndon-b-johnson-elementary-school",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_57d6108e-4bce-46be-8fe0-7f22925b87ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "poi_name": "Alamo Drafthouse Cinema Montecillo",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "alamo-drafthouse-cinema-montecillo",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9c7c4aea238491fb6b809458",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1505ce5e155561fe19327a76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0be63529e4bcf6d97c7ad673",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a627849206de94a8aacabed6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b54085f9f13850f7635af98b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_1e7190bc7c4289e5c2986494",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7f46146b-53b4-43d4-97eb-75123f14006f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "rating": "5.0",
      "name": "David Paseornek",
      "text": "In my opinion, this is the best apartment complex on the west side of El Paso. Anytime I’ve had an issue the office staff is friendly and take immediate action. Maintenance also is excellent.. Only drawback is the price continues to climb, but I guess that’s everywhere.",
      "date": "2025-09-10",
      "title": ""
    },
    {
      "id": "custom_fe675397-b872-4a38-9fd2-f220b0363502",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "rating": "5.0",
      "name": "Syl S",
      "text": "The apartments reminds me of home, when I used to live in Seattle during the 90s. The trees the view of the mountains, especially when it rains it calls home",
      "date": "2025-07-28",
      "title": ""
    },
    {
      "id": "custom_0e602945-d1dd-4a58-a118-e559e2e6b271",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "rating": "5.0",
      "name": "Sandra Duarte",
      "text": "A main wire that was connected to our unit went out. It affected our air, stove and dryer. The guys were amazing, figuring out the problem and they arrived early morning to start on the problem.",
      "date": "2025-09-08",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_04cbe7db-5278-4c38-9b63-49109792c2d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb38-5d0a-73af-b6b0-ea1a3fdeead8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of the property's outdoor swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfb38-5d0a-73af-b6b0-ea1a3fdeead8",
        "storage_key": "property/6767906449165582/019cfb38-5d0a-73af-b6b0-ea1a3fdeead8.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Acacia Park Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6303469b3bd8dd2e49eb440b"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-95a3-74af-959c-d2fb834028b0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "acacia-park-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582"
    },
    {
      "lead_collector_id": "019cf79d-9612-7640-8e1f-8dfee6255ec9",
      "lead_source": "LANDING_PAGE",
      "name": "acacia-park-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-el-paso",
      "search_query": "in-unit laundry apartments el paso",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in El Paso",
      "h2_subtitle": "Discover stylish in-unit laundry apartments in El Paso. Acacia Park Apts. offers modern conveniences and a welcoming community.",
      "page_copy": "Looking for in-unit laundry apartments in El Paso? Acacia Park Apts. has you covered with our modern residences that prioritize comfort and convenience. Nestled in the charming Upper Mesa Hills neighborhood, our community provides spacious one to three-bedroom floor plans designed to fit your lifestyle. Enjoy a seamless apartment experience with amenities such as a refreshing pool, a well-equipped fitness center, and dedicated package service—ideal for busy lifestyles.\n\nAt Acacia Park Apts., every detail is crafted with residents’ needs in mind, including easy access to in-unit laundry facilities. Our friendly community atmosphere is perfect for both relaxation and activity. Take a stroll with your pet in our dog park or spend an afternoon with family at the playground. Choose Acacia Park Apts. and relish in a modern way of living right here in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments El Paso | Acacia Park",
      "seo_description": "Explore Acacia Park Apts. in El Paso for in-unit laundry apartments. Modern living with great amenities in Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-upper-mesa-hills",
      "search_query": "dog friendly apartments upper mesa hills",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Upper Mesa Hills",
      "h2_subtitle": "Explore dog-friendly apartments in Upper Mesa Hills. Acacia Park Apts. is ideal for pet lovers with ample amenities.",
      "page_copy": "Discover the ultimate pet-friendly environment at Acacia Park Apts., offering dog-friendly apartments in the scenic Upper Mesa Hills. Our community prioritizes both style and comfort, featuring spacious floor plans from one to three bedrooms that accommodate both you and your furry friend. Step outside to our dedicated dog park, where your pet can roam and play while you enjoy the company of fellow pet enthusiasts.\n\nAcacia Park Apts. is more than just a pet-friendly community; we offer a comprehensive living experience. Enjoy a swim in our refreshing pool, perfect for unwinding after a day of exploring El Paso or working out in our modern fitness center. With residents' needs in mind, the amenities at Acacia Park are tailored to enhance everyday living, making it the perfect home for you and your pet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Upper Mesa Hills | Acacia Park",
      "seo_description": "Find dog-friendly apartments at Acacia Park in Upper Mesa Hills. Perfect setting for pet lovers, featuring dog park and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "apartments-with-pool-el-paso-tx",
      "search_query": "apartments with pool el paso tx",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in El Paso, TX",
      "h2_subtitle": "Explore apartments with a pool in El Paso, TX. Enjoy leisure and fitness at Acacia Park Apts. in Upper Mesa Hills.",
      "page_copy": "Looking for apartments with a pool in El Paso, TX? Acacia Park Apts. offers a perfect blend of leisure and luxury in the desirable Upper Mesa Hills neighborhood. Our inviting community features a spacious swimming pool, ideal for unwinding after a busy day or enjoying a sunny weekend. Dive into relaxation not far from your doorstep and alongside neighbors who appreciate easygoing Texas living.\n\nBeyond the pool, Acacia Park Apts. provides amenities that enhance your lifestyle, including a cutting-edge fitness center, playground, and dog park. Choose from one to three-bedroom apartments, each designed with comfort in mind, complete with cable readiness and ample linen closet space. Acacia Park Apts. is where modern conveniences meet a vibrant community setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool El Paso, TX | Acacia Park",
      "seo_description": "Discover Acacia Park Apts. in El Paso, TX for apartments with a pool. Experience modern living in Upper Mesa Hills with ample amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-el-paso",
      "search_query": "air conditioned apartments in el paso",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in El Paso",
      "h2_subtitle": "Find air conditioned apartments in El Paso. Stay cool and comfortable at Acacia Park Apts. in Upper Mesa Hills.",
      "page_copy": "Experience ultimate comfort with air conditioned apartments in El Paso at Acacia Park Apts. Designed with modern living in mind, our community ensures a cozy and cool environment in the heat of Texas. Nestled in the Upper Mesa Hills, our complex offers spacious one to three-bedroom floor plans, allowing you to choose the perfect fit for your lifestyle.\n\nLiving at Acacia Park Apts. goes beyond just air conditioning. Enjoy the benefits of a refreshing swimming pool, a well-maintained fitness center, and recreational spaces like a playground and dog park. Our cable-ready units also feature ample storage with linen closets, ensuring a convenient and hassle-free living experience. Discover a community that seamlessly integrates comfort, style, and the perfect temperature all year round.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments El Paso | Acacia Park",
      "seo_description": "Stay comfortable in air conditioned apartments at Acacia Park in El Paso. Enjoy modern living in Upper Mesa Hills with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-79912",
      "search_query": "pet friendly apartments with dog park near 79912",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments Near 79912",
      "h2_subtitle": "Discover pet-friendly apartments with a dog park near 79912. Acacia Park Apts. welcomes you and your pets in Upper Mesa Hills.",
      "page_copy": "If you're searching for pet-friendly apartments with a dog park near 79912, discover Acacia Park Apts. Located in the charming Upper Mesa Hills, our community is a haven for pet lovers. We offer spacious living spaces ranging from one to three bedrooms, ensuring comfort for you and ample room for your pets. Our dedicated dog park provides a safe and engaging environment for your furry companions to play and socialize.\n\nAcacia Park Apts. extends beyond just pet-friendly features. Enjoy a wide array of amenities like our invigorating swimming pool, modern fitness center, and convenient package service. Our residences are cable ready and include handy linen closets, making everyday living a breeze. Join a community that celebrates the bond between you and your pets, while offering modern comforts and an inviting atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Park Near 79912",
      "seo_description": "Find pet-friendly apartments with a dog park at Acacia Park near 79912. Enjoy spacious living in Upper Mesa Hills with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-upper-mesa-hills",
      "search_query": "1 bedroom apartments upper mesa hills",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Upper Mesa Hills",
      "h2_subtitle": "Looking for 1 bedroom apartments in Upper Mesa Hills? Explore comfortable living at Acacia Park Apts. in El Paso.",
      "page_copy": "Discover the perfect retreat with 1 bedroom apartments in Upper Mesa Hills at Acacia Park Apts. Situated in one of El Paso's most desirable neighborhoods, our community provides comfortable and modern living options tailored to match your lifestyle. Each apartment is cable ready, offering convenience alongside spacious living areas and well-designed floor plans.\n\nAt Acacia Park Apts., we pride ourselves on providing more than just a home. Enjoy access to excellent amenities including a refreshing swimming pool, a fully equipped fitness center, and a playful playground. Additionally, our community features a dog park, perfect for pet owners looking to give their furry friends a place to enjoy. With our welcoming environment and convenient location, Acacia Park Apts. is the ideal choice for anybody seeking one bedroom apartments in Upper Mesa Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Upper Mesa Hills | Acacia Park",
      "seo_description": "Find 1 bedroom apartments in Upper Mesa Hills at Acacia Park. Enjoy modern amenities and a convenient El Paso location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-el-paso-tx",
      "search_query": "2 bedroom apartments el paso tx",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in El Paso, TX",
      "h2_subtitle": "Explore 2 bedroom apartments in El Paso, TX. Acacia Park Apts. offers spacious living in a prime location in Upper Mesa Hills.",
      "page_copy": "For those in search of 2 bedroom apartments in El Paso, TX, Acacia Park Apts. provides the ideal living environment. Located in the serene Upper Mesa Hills neighborhood, our two-bedroom floor plans are designed with both style and functionality in mind. Each unit is cable ready and features ample storage with linen closets, offering comfort and convenience.\n\nAt Acacia Park Apts., residents indulge in a variety of amenities such as an invigorating swimming pool, a comprehensive fitness center, and a playful recreation area. Families and pet owners alike will appreciate our playground and dedicated dog park, creating a welcoming community feel. Positioned in a vibrant area of El Paso, Acacia Park Apts. is perfect for those seeking a blend of modern living and community-oriented amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments El Paso, TX | Acacia Park",
      "seo_description": "Discover 2 bedroom apartments in El Paso, TX at Acacia Park. Spacious living with great amenities in Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-79912",
      "search_query": "3 bedroom apartments near 79912",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 79912",
      "h2_subtitle": "Discover spacious 3 bedroom apartments near 79912 at Acacia Park Apts., located in Upper Mesa Hills, El Paso.",
      "page_copy": "Searching for spacious 3 bedroom apartments near 79912? Look no further than Acacia Park Apts. in the picturesque Upper Mesa Hills neighborhood. Our three-bedroom units offer generous living spaces, ideal for families or those needing extra room. Each apartment is thoughtfully designed, featuring cable readiness and convenient storage options, including linen closets.\n\nAt Acacia Park Apts., residents enjoy a wide array of community amenities such as a refreshing swimming pool, a fully equipped fitness center, and a family-friendly playground. We also offer a secure dog park, catering to pet owners who want the best for their furry friends. Experience the perfect blend of comfort and community in a prime El Paso location when you choose Acacia Park Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 79912 | Acacia Park",
      "seo_description": "Find spacious 3 bedroom apartments near 79912 at Acacia Park in Upper Mesa Hills, El Paso. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-texas-el-paso",
      "search_query": "apartments near University of Texas El Paso",
      "category": "School",
      "h1_title": "Apartments Near University of Texas El Paso",
      "h2_subtitle": "Explore convenient apartments near University of Texas El Paso. Acacia Park Apts. offers ideal student living options.",
      "page_copy": "Looking for apartments near the University of Texas El Paso? Acacia Park Apts. provides the perfect living space for students and faculty alike. Located just a short drive from UTEP, our community in Upper Mesa Hills offers spacious one to three-bedroom layouts that cater to a variety of needs.\n\nOur residents enjoy a range of amenities including a modern fitness center, a relaxing swimming pool, and a playful children's playground. With cable-ready units and ample storage options like linen closets, Acacia Park Apts. ensures a seamless living experience. The inclusion of a dog park fosters a welcoming community environment, perfect for pet owners. Choose Acacia Park Apts. for a comfortable and convenient lifestyle near the University of Texas El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Texas El Paso | Acacia Park",
      "seo_description": "Find apartments near University of Texas El Paso at Acacia Park. Enjoy quick access to campus and great amenities in Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "rentals-close-to-el-paso-community-college-rio-grande",
      "search_query": "rentals close to El Paso Community College Rio Grande Campus",
      "category": "School",
      "h1_title": "Rentals Close to El Paso Community College",
      "h2_subtitle": "Discover rentals close to El Paso Community College Rio Grande Campus. Acacia Park Apts. offers ideal accommodations in El Paso.",
      "page_copy": "If you’re searching for rentals close to El Paso Community College Rio Grande Campus, Acacia Park Apts. offers an outstanding choice. Situated in the peaceful Upper Mesa Hills, our community provides easy access to EPCC, making it an excellent option for students, faculty, and staff.\n\nOur spacious one to three-bedroom apartments are perfect for creating a comfortable study and living environment. Residents can enjoy modern amenities such as a well-equipped fitness center, a relaxing swimming pool, and a family-friendly playground. Each apartment is cable ready with ample storage, including linen closets, ensuring convenience. Acacia Park Apts. is the ideal place to settle, combining tranquility with close proximity to educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to El Paso Community College Rio Grande",
      "seo_description": "Find rentals close to El Paso Community College Rio Grande Campus at Acacia Park. Enjoy student-friendly amenities in Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "apartments-near-las-palmas-medical-center-el-paso",
      "search_query": "apartments near Las Palmas Medical Center El Paso",
      "category": "Hospital",
      "h1_title": "Apartments Near Las Palmas Medical Center",
      "h2_subtitle": "Find comfortable apartments near Las Palmas Medical Center in El Paso. Acacia Park Apts. offers a convenient living experience nearby.",
      "page_copy": "Discover convenient living with apartments near Las Palmas Medical Center El Paso at Acacia Park Apts. Perfectly situated in the serene Upper Mesa Hills neighborhood, our community provides excellent access for medical professionals and staff working at the center.\n\nOur range of apartment options includes spacious one to three-bedroom units, designed for comfort and ease. Residents can enjoy various community amenities such as a state-of-the-art fitness center, a sparkling swimming pool, and a vibrant playground for families. Each apartment comes equipped with cable readiness and thoughtful storage solutions like linen closets. With Acacia Park Apts., experience a community-focused environment within close proximity to Las Palmas Medical Center, making your daily commute stress-free and straightforward.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Las Palmas Medical Center | Acacia Park",
      "seo_description": "Discover apartments near Las Palmas Medical Center in El Paso at Acacia Park. Enjoy easy access and modern amenities in Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "acacia-park-apts-close-to-hospitals-of-providence",
      "search_query": "acacia park apts close to hospitals of providence memorial campus 79912",
      "category": "Hospital",
      "h1_title": "Acacia Park Apts. Close to Hospitals",
      "h2_subtitle": "Discover Acacia Park Apts. close to Hospitals of Providence Memorial Campus. Convenient living in El Paso's 79912 area.",
      "page_copy": "Acacia Park Apts. offers the ideal proximity to the Hospitals of Providence Memorial Campus, making it a top choice for healthcare professionals seeking residences close to work. Nestled in the tranquil Upper Mesa Hills of El Paso, our community provides easy access to the medical campus at ZIP code 79912.\n\nOur spacious one, two, and three-bedroom apartments are designed with comfort in mind, offering amenities like a modern fitness center, a refreshing swimming pool, and a playful on-site playground. Each unit comes cable ready with added conveniences such as a linen closet and package service. Choosing Acacia Park Apts. means opting for a supportive living environment that balances work with relaxation, all within a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Acacia Park Apts. Close to Hospitals of Providence",
      "seo_description": "Explore Acacia Park Apts. near Hospitals of Providence in the 79912 area. Enjoy convenient living and modern amenities in Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "apartments-near-franklin-mountains-state-park",
      "search_query": "apartments near Franklin Mountains State Park El Paso",
      "category": "Park",
      "h1_title": "Apartments Near Franklin Mountains State Park",
      "h2_subtitle": "Discover apartments near Franklin Mountains State Park in El Paso. Enjoy scenic views and outdoor adventure at Acacia Park Apts.",
      "page_copy": "For nature enthusiasts seeking apartments near Franklin Mountains State Park El Paso, Acacia Park Apts. combines comfort with spectacular scenery. Located in the picturesque Upper Mesa Hills, our community is just a short drive from the park, offering residents easy access to hiking trails and natural beauty.\n\nChoose from our spacious one to three-bedroom apartments, each featuring modern amenities. Residents will love facilities like a refreshing pool, a fully-equipped fitness center, and a family-friendly playground. Our units come cable ready, with ample storage including linen closets. At Acacia Park Apts., enjoy a lifestyle that brings you close to outdoor adventures while offering comfort at home. Experience the perfect blend of convenience and tranquility in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Franklin Mountains State Park",
      "seo_description": "Find apartments near Franklin Mountains State Park at Acacia Park. Enjoy convenient living with natural beauty at your doorstep in Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "apartments-close-to-memorial-park-tx",
      "search_query": "apartments close to Memorial Park TX",
      "category": "Park",
      "h1_title": "Apartments Close to Memorial Park, TX",
      "h2_subtitle": "Find ideal apartments close to Memorial Park, TX, at Acacia Park Apts., offering convenient and comfortable living in El Paso.",
      "page_copy": "Acacia Park Apts. offers the perfect location for those seeking apartments close to Memorial Park, TX. Situated in the charming Upper Mesa Hills of El Paso, our community provides easy access to the park, allowing residents to enjoy outdoor activities and a serene environment.\n\nOur spacious one, two, and three-bedroom apartments are designed for modern living. Indulge in community amenities like a refreshing swimming pool, a state-of-the-art fitness center, and a family-friendly playground. Each unit is cable ready, with added conveniences such as a linen closet and efficient package service. Choose Acacia Park Apts. for a balanced lifestyle that mixes recreation with relaxation, in close proximity to Memorial Park, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Memorial Park, TX | Acacia Park",
      "seo_description": "Discover Acacia Park Apts. near Memorial Park, TX. Enjoy comfortable living with modern amenities in El Paso's Upper Mesa Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "apartment-living-by-parque-publico-el-chamizal",
      "search_query": "apartment living by Parque Público Federal El Chamizal El Paso",
      "category": "Park",
      "h1_title": "Apartment Living by El Chamizal, El Paso",
      "h2_subtitle": "Experience apartment living by Parque Público Federal El Chamizal. Acacia Park Apts. offers convenience and comfort in El Paso.",
      "page_copy": "For those seeking apartment living by Parque Público Federal El Chamizal in El Paso, Acacia Park Apts. offers an unmatched blend of comfort and convenience. Located within easy reach of this vibrant park, our community is perfect for those who love exploring local culture and nature.\n\nChoose from a variety of spacious floor plans, ranging from one to three bedrooms, all equipped with modern features. You will enjoy amenities including a refreshing swimming pool, a fully-equipped fitness center, and a playground perfect for families. Each apartment is cable ready and offers thoughtful touches like a linen closet and package service. Embrace a lifestyle that bridges urban living with natural surroundings at Acacia Park Apts., near El Chamizal, El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living by El Chamizal, El Paso",
      "seo_description": "Discover convenient apartment living by Parque Público Federal El Chamizal at Acacia Park Apts., featuring modern amenities in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165582",
      "source": "generator",
      "page_item_url": "upper-mesa-hills-apartments-near-dif-park",
      "search_query": "Upper Mesa Hills apartments near DIF Park",
      "category": "Park",
      "h1_title": "Upper Mesa Hills Apartments Near DIF Park",
      "h2_subtitle": "Explore Upper Mesa Hills apartments near DIF Park at Acacia Park Apts., where comfort meets convenience in El Paso.",
      "page_copy": "If you're searching for Upper Mesa Hills apartments near DIF Park, Acacia Park Apts. is an ideal choice. Nestled in this scenic neighborhood, our community provides a perfect blend of tranquility and accessibility, just a stone's throw away from the vibrant DIF Park.\n\nOffering spacious one to three-bedroom floor plans, Acacia Park Apts. delivers modern amenities for a comfortable lifestyle. Residents can relax by the refreshing pool, engage in workouts at the on-site fitness center, or enjoy family time at the playground. Our apartments feature conveniences like being cable ready and offering ample storage with linen closets. With a location just minutes from DIF Park, Acacia Park Apts. is your gateway to a lifestyle filled with both relaxation and recreation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
      "featured_image_media": {
        "alt_text": "Communal lounge area with fireplace, dining table, kitchen, and seating.",
        "public_id": "019cfb37-977b-7112-b49b-bbbc88bffb2e",
        "storage_key": "property/6767906449165582/019cfb37-977b-7112-b49b-bbbc88bffb2e.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Upper Mesa Hills Apartments Near DIF Park",
      "seo_description": "Find your home at Acacia Park Apts. in Upper Mesa Hills, ideally located near DIF Park, offering spacious living and modern amenities in El Paso.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5141"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-6FC7FPRLY5"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151068"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/acacia-park-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MW42XP96"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165582/019d1bd6-ad7f-75bb-9b77-9d9e570d6e5c.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47606143147"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "625de91b-6af0-48b3-bb12-42684ea9452f"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-794-3108"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "63c834c46489008da8373326"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjY0OC9ON2FtZHo3T2VURHRuV0NrcWc9PSIsInZhbHVlIjoiZFRZT3IxK1EwSWhlUVk2YU9FSjNLQT09IiwibWFjIjoiNDk3ZmQxOTk1ODg5Zjc2MzhjYjJmMjkwYzhmMjFjMDM1ZDE0NjQ4ZWUwYTc4YTVjNjcwZTZiZjRhZThlZTZjOCJ9"
    }
  ],
  "custom_qb_id": "5141",
  "custom_ga4_id": "G-6FC7FPRLY5",
  "custom_repli_id": "10041151068",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/acacia-park-apartments/register/",
  "custom_google_gtm_id": "GTM-MW42XP96",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165582/019d1bd6-ad7f-75bb-9b77-9d9e570d6e5c.pdf",
  "custom_hubspot_company_id": "47606143147",
  "custom_rentgrata_property_id": "625de91b-6af0-48b3-bb12-42684ea9452f",
  "custom_ppc_tracking_phone_number": "844-794-3108",
  "custom_residentboost_apartment_id": "63c834c46489008da8373326",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjY0OC9ON2FtZHo3T2VURHRuV0NrcWc9PSIsInZhbHVlIjoiZFRZT3IxK1EwSWhlUVk2YU9FSjNLQT09IiwibWFjIjoiNDk3ZmQxOTk1ODg5Zjc2MzhjYjJmMjkwYzhmMjFjMDM1ZDE0NjQ4ZWUwYTc4YTVjNjcwZTZiZjRhZThlZTZjOCJ9"
};

export const generatedAt = '2026-08-27T21:39:49.920Z';
